import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, OnDestroy, ViewChildren, QueryList } from "@angular/core";
import { HttpHelpUtils } from "../../../../../utils/HttpHelpUtils";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BaseCommpont } from "./../../../../../utils/BaseCommpont";
import { DomSanitizer } from "@angular/platform-browser";
import { ConfirmationService } from "primeng/api";
import { RegExUtils } from "../../../../../utils/RegExUtils";
import { Router, ActivatedRoute } from "@angular/router";
import { LocalStorage } from "../../../../../utils/LocalStorage";
import { ImagePreviewService } from "./../../../../../components/image-viewer/image-preview.service";
import { MessageSub } from "./../../../../../utils/MessageSub";
import { emptyDataTrigger, filterTrigger, serachTrigger } from "../../../../../utils/Animations";
import { OssFileService } from "./../../../../../components/oss-file/oss-file.service";
import StatusUtils from "./../../../../../utils/StatusUtils";
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from "@techiediaries/ngx-qrcode";
import { environment } from "./../../../../../../environments/environment";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-driver",
  templateUrl: "./driver.component.html",
  styleUrls: ["./driver.component.scss"],
  providers: [ConfirmationService],
  animations: [emptyDataTrigger, filterTrigger, serachTrigger],
})
export class DriverComponent extends BaseCommpont implements OnInit, AfterViewInit, OnDestroy {
  //格式化时间
  pipe = new DatePipe("en-US");
  change(dateStr, format?) {
    let changedFormat = this.pipe.transform(dateStr, format ? format : "yyyy-MM-dd HH:mm:ss");
    return changedFormat;
  }
  searchForm: FormGroup; // 查询表单
  validateForm: FormGroup; // 编辑表单
  validateFormPhone: FormGroup; // 验证司机身份证表单
  checkDriverForm: FormGroup; // 审核司机表单
  bindTruckUserForm: FormGroup;
  regExUtils = new RegExUtils(); // 校验规则
  noCheckWaybillDialogFlag = false;
  checkWaybillForm: FormGroup;
  editDialogType = 1;

  truckValidateForm: FormGroup;

  flag = 0;
  searchShipperList = [];
  ShipperList = [];
  agentIdList = [];

  agentMap = {};
  levelMap = {}; //会员等级 id map
  searchAgentList = [];
  shipperMap = {};
  @ViewChild("fileUpload") fileUpload: ElementRef; // 上传司机数据虚拟组件
  @ViewChild("importfileUpload") basicfileUpload: ElementRef; // 上传司机数据虚拟按钮
  @ViewChild("uploadTruckInput") uploadTruckInput: ElementRef; // 上传司机数据虚拟按钮
  @ViewChild("qualificationCertPhotoInput") qualificationCertPhotoInput: ElementRef; // 上传司机数据虚拟按钮
  checkList = [];

  first = 0; // 首页
  batchMobilePhoneDialog = false; //批量司机弹窗
  batchIdCardNoDialog = false; //批量身份证号弹窗
  batchNoForm: FormGroup;
  batchIdCardNoForm: FormGroup;
  memberValidateForm: FormGroup; //司机成为会员
  addMemberDialog = false; //成为会员弹框
  editDriverIdCardDialogFlag = false; // 司机身份证验证
  identifyIdCardFrontUrl = ""; // 验证司机身份证正面照片
  id_card_no_front_url = ""; // 身份证正面
  id_card_no_back_url = ""; // 身份证背面
  driving_license_photo_url = ""; // 驾驶证
  uploadCurrentType = ""; // 公共选择上传文件，当前选中得类型
  checkDriverDialog = false; // 批量审核司机弹窗
  showDriverFlag = false; // 显示司机详情
  driverDetail = []; // 司机详情
  mobilePhoneList: any[] = []; // C端手机号列表
  dialogTitle = ""; // 公共上传title
  dialogSubTitle = ""; // 公共上传子title
  idCodeNo = "";
  vehicleTypeList = []; // 车辆类型列表
  useCharacterList = []; //使用性质
  truckSizeList = []; //车辆尺寸
  modelList = []; //车辆品牌
  driverTypeList = []; //准假车型

  saleUserNameList = [];
  levelList = [{ label: "--选择--", value: "", price: "" }]; //会员等级
  salesmanList = [{ label: "--选择--", value: "" }]; //业务员
  driverTypeMap = {};
  politicalOutlookLists = []; //政治面貌
  politicalOutlookMap = {}; //政治面貌
  bankForceBindStatus = 0; // 银行卡强制绑卡状态：0-关闭，1-开启
  bankCardNo = "";
  importDialog = false; // 导入弹窗
  uploadedFiles: any[] = []; // 上传图片
  uploadCommonDialog = false; // 公共上传
  operateDriverItem = []; // 操作上传的司机数据
  saveDriverUploadFile = ""; // 上传司机身份证地址
  saveDriverUrl = ""; // 保存司机编辑数据地址
  uploadName = "uploadEditFile"; // 上传表单name
  validateRelDriverForm: FormGroup; //司机关联托运方表单
  editIdCardDialogFlag = false;
  validateRelAgentDriverForm: FormGroup; //司机关联区域合伙人表单
  editAgentDriverDialogFlag = false;

  saveBankUpload = this.httpHelp.checkFullPath("member/driverMan/saveBankUploadFile");
  saveIdCardUrl = this.httpHelp.checkFullPath("member/driverMan/saveIdCardUploadFile");
  uploadItems = [
    // 单独传证件
    { uploadFileTitle: "身份证正面", uploadType: "id_card_front", uploadSubHeader: "" },
    { uploadFileTitle: "身份证反面", uploadType: "id_card_back", uploadSubHeader: "" },
    { uploadFileTitle: "驾驶证照片", uploadType: "driver_license", uploadSubHeader: "" },
  ];
  qualificationCertPhotoUrl; //司机从业资格证
  drivingLicenseBackPhotoUrl; //驾驶证副页
  editUploadFiles = {
    // 编辑表单文件上传
    id_card_no_front: "",
    id_card_no_back: "",
    driving_license_photo: "",
    driving_license_back_photo: "",
    vehicle_license_photo: "",
    vehicle_license_back_photo: "",
    business_certificate_photo: "",
    driver_truck_photo: "",
    opt_cert_photo: "",
    qualification_cert_photo: "",
    vehicle_license_check_photo: "",
    mounting_agreement_photo: "",
  };

  uploadFileUrl = {
    vehicleLicensePhotoUrl: "",
    vehicleLicenseBackPhotoUrl: "",
    businessCertificatePhotoUrl: "",
    optCertPhotoUrl: "",
    drivingLicensePhotoUrl: "",
    drivingLicenseBackPhotoUrl: "",
    idCardFrontUrl: "",
    idCardBackUrl: "",
    qualificationCertPhotoUrl: "",
  };

  plateColorLists = []; //车牌颜色
  energyTypeLists = []; //车辆能源类型
  isPersonalLists = []; //车辆属性
  useCharacterLists = []; //使用性质
  plateColorMap = {}; //车牌颜色
  vehicleTypeMap = {};
  energyTypeMap = {}; //车辆能源类型
  isPersonalMap = {}; //车辆属性
  useCharacterMap = {}; //使用性质
  vehicleLicensePhotoUrl; //行驶证主页
  vehicleLicenseBackPhotoUrl; //行驶证副页
  businessCertificatePhotoUrl; //经营性许可证
  teamIdList = []; //车主ID
  optCertPhotoUrl; //道路运输证
  driverTruckPhotoUrl; //人车照
  truckModelMap = {}; //车型
  truckSizeMap = {}; //车长
  truckModelLists = []; //车型
  truckSizeLists = []; //车辆尺寸
  @ViewChild("vehicleLicensePhotoInput") vehicleLicensePhotoInput: ElementRef; //主页行驶证
  @ViewChild("vehicleLicenseBackPhotoInput") vehicleLicenseBackPhotoInput: ElementRef; //行驶证副页
  @ViewChild("businessCertificateInput") businessCertificateInput: ElementRef; //经营许可证
  @ViewChild("optCertPhotoFileInput") optCertPhotoFileInput: ElementRef; //道路运输证
  @ViewChild("driverTruckInput") driverTruckInput: ElementRef; //人车证

  idCardFrontUrl; //身份证正面
  idCardBackUrl; //身份证反面
  drivingLicensePhotoUrl; //驾驶证照片
  @ViewChild("idCardFrontInput") idCardFrontInput: ElementRef; //身份证正面照片清除按钮
  @ViewChild("idCardBackInput") idCardBackInput: ElementRef; //身份证反面照片清除按钮
  @ViewChild("drivingLicensePhotoInput") drivingLicensePhotoInput: ElementRef; //驾驶证照片清除按钮
  @ViewChild("drivingLicenseBackPhotoInput") drivingLicenseBackPhotoInput: ElementRef; //驾驶证副页照片清除按钮
  @ViewChild("editUploadInput") editUploadInput: ElementRef; // 上传银行卡虚拟按钮

  //关联车主开始
  relTeam = {
    relTeamDialogFlag: false,
    selectedRelTeamList: [],
    relTeamList: [],
    addRelTeamDialogFlag: false,
    teamIdList: [],
  };

  signContractDialog = false; // 签署合同窗口
  signContractForm: FormGroup; // 签署合同表单
  showQCodeFlag = false; // 二维码签署弹窗

  saveDriverReditUrl = "";
  checkFlag = {
    // 审核状态
    0: "待提交",
    1: "待审核",
    2: "已审核",
    3: "审核不过",
    4: "未实名",
  };
  njbkVirtualAccountStatusMap(value: number | null = null) {
    switch (value) {
      case 1:
        return {
          background: "#EE9A00",
          text: "未开户",
        };
        break;
      case 2:
        return {
          background: "#B15BFF",
          text: "已开户",
        };
        break;
      case 3:
        return {
          background: "#00A600",
          text: "已冻结",
        };
        break;
      case 4:
        return {
          background: "#EA0000",
          text: "已注销",
        };
        break;
    }
  }
  signStatus = {
    0: "待签署",
    1: "签署中",
    2: "已签署",
    3: "签署失败",
  };

  noSignStatus = {
    1: "未认证",
    2: "待授权",
    3: "已签署",
  };
  faceIdentifyStatus = {
    1: "未核验",
    2: "核验成功",
    3: "核验失败",
  };
  //审核状态颜色
  getCheckFlag = (val) => {
    if (val == 0) {
      return "#EE9A00";
    } else if (val == 1) {
      return "#B15BFF";
    } else if (val == 2) {
      return "#00A600";
    } else if (val == 3) {
      return "#EA0000";
    }
  };
  statusItems = this.getLocalDropdown(this.checkFlag, true); // 审核状态列表
  // ==========================================我的银行卡 start===========================
  validateBankForm: FormGroup; // 上传银行卡
  smsCountDown = 0;
  smsTimer: any;
  myBank = {
    bankDataList: "", // 银行列表
    selectedBankList: [], // 选中的银行卡数据
    editMyBankDialogFlag: false, // 新增银行卡
    uploadBankCard: "", // 上传银行卡
    myBnakListDialogFlag: false, // 我的银行卡列表
    bankPhotoUrl: "", // 银行卡url
  };
  // ==========================================我的银行卡 end=============================

  // ==========================================我的车辆 start=============================
  @ViewChild("fileUploadTruck") fileUploadTruck: ElementRef; // 编辑车辆上传虚拟组件
  @ViewChild("basicTruckUpload") basicTruckUpload: ElementRef; // 编辑车辆按钮虚拟组件
  validateTruckForm: FormGroup; // 编辑车辆信息表单
  myTruck = {
    plateNumber: "", // 车牌号
    showTruckDetailFlag: false, // 显示车辆详情
    truckDetailHeader: "", // 设置车辆标题
    saveTruckUrl: "", // 保存编辑车辆数据
    uploadTruckName: "vehLicUploadfile", // 上传标识
    tempTruckId: "", // 临时车辆id
    vehicle_license_photo_url: "", // 行驶证照片
    opt_cert_photo_url: "",
    business_certificate_photo_url: "", // 经营许可证
    driver_truck_photo_url: "", // 人车照片
    driverTruckPhotoFlag: false, // 上传人车照标识
    truckDetail: [], // 车辆详情
    myTruckListDialogFlag: false, // 我的车辆设置
    trucksDataList: [], // 车辆列表
    selectedTruckList: [], // 选中的车辆数据
    truckEditDialogFlag: false, // 新增车辆基本信息
    truckCheckDialogFlag: false, // 校验车牌号
    uploadTruckPhotoUrl: "", // 上传人车照地址
    checkDriverTruckDialogFlag: false,
    noTruckDataList: [], //车辆数据
    noSelectTruckDataList: [],
  };
  // ==========================================我的车辆 end===============================
  queryTypeList = [
    // 审核状态
    { value: "", label: "全部" },
    { value: 0, label: "待提交" },
    { value: 1, label: "待审核" },
    { value: 2, label: "已审核" },
    { value: 3, label: "审核通过" },
  ];
  onlineList = [
    // 入网状态
    { value: 1, label: "查不到入网" },
    { value: 2, label: "未入网" },
    { value: 3, label: "已入网" },
  ];
  useStatus = {
    // 使用状态
    0: "空闲",
    1: "工作中",
  };
  status = {
    // 使用状态
    0: "正常",
    1: "停用",
    2: "注销",
  };

  statusList = [
    // 使用状态
    { value: "", label: "全部" },
    { value: 0, label: "正常" },
    { value: 1, label: "停用" },
    { value: 2, label: "注销" },
  ];

  driverType = {
    // 使用状态
    A1: "A1(大型客车)",
    A2: "A2(牵引车)",
    A3: "A3(城市公交车)",
    B1: "B1(中型客车)",
    B2: "B2(大型货车)",
    C1: "C1(小型汽车)",
    C2: "C2(小型自动挡汽车)",
    C3: "C3(低速载货汽车)",
    C4: "C4(三轮汽车)",
  };
  useStatusList = [
    { value: "", label: "全部" }, // 司机空闲状态
    { value: 0, label: "空闲" },
    { value: 1, label: "工作中" },
  ];
  sex = {
    1: "男",
    0: "女",
  };
  sexMap = {
    1: "男",
    2: "女",
  };
  sexList = this.getLocalDropdown(this.sexMap, true);
  //来源（0：系统录入，1：数据导入，2：小程序，3：app）
  source = {
    0: "系统录入",
    1: "EXECL导入",
    2: "微信小程序",
    3: "司机端APP",
  };
  //签署状态,0:待签署，1：签署中，2：签署完成，3：签署失败
  // signStatus = {
  //     0: '待签署',
  //     1: '签署中',
  //     2: '已签署',
  //     3: '签署失败'
  // }

  signStatusMap = {
    10: "待签署",
    1: "签署中",
    2: "已签署",
    3: "签署失败",
  };
  signStatusList = this.getLocalDropdown(this.signStatusMap, true);
  //签署来源
  signSource = {
    1: "网页签署",
    2: "小程序签署",
    3: "APP签署",
  };
  //是否黑名单
  blacklistStatus = {
    1: "是",
    0: "否",
  };
  blacklistStatusList = this.getLocalDropdown(this.blacklistStatus, true);
  reportStatus = {
    0: "无上报",
    1: "未上报",
    2: "上报成功",
    3: "上报失败",
  };
  //开户状态 0：未开户，1：开户成功，2：开户失败
  openStatus = {
    0: "未开户",
    1: "开户成功",
    2: "开户失败",
  };
  keysFunction = {
    // 由于方法不能存于缓存，特此添加方法区
    useStatus: {
      format: (val, row?) => {
        return this.useStatus[val];
      },
      colorFormat: (val, row?) => {
        return StatusUtils.getUseStatus(val);
      },
    },
    status: {
      format: (val, row?) => {
        return this.status[val];
      },
      colorFormat: (val, row?) => {
        return StatusUtils.getDriverStatus(val);
      },
    },
    checkFlag: {
      format: (val, row?) => {
        return this.checkFlag[val];
      },
      colorFormat: (val, row?) => {
        return StatusUtils.getCheckFlag(val);
      },
    },
    driverType: {
      format: (val, row?) => {
        return this.driverTypeMap[val];
      },
    },
    agentId: {
      format: (val, row?) => {
        return this.agentMap[val];
      },
    },
    cusId: {
      format: (val, row?) => {
        return this.shipperMap[val];
      },
    },
    politicalOutlook: {
      format: (val, row?) => {
        return this.politicalOutlookMap[val];
      },
      colorFormat: (val, row?) => {
        return { color: StatusUtils.getPoliticalOutlook(val), fontWeight: "700" };
      },
    },
    sex: {
      format: (val, row?) => {
        return this.sex[val];
      },
      colorFormat: (val, row?) => {
        return { color: StatusUtils.getSex(val), fontWeight: "700" };
      },
    },
    birthDate: {
      format: (val, row?) => {
        return this.setCreateTime(val * 1000, "yyyy-MM-dd");
      },
    },
    startUseDate: {
      format: (val, row?) => {
        return this.setCreateTime(val * 1000, "yyyy-MM-dd");
      },
    },
    effectTime: {
      format: (val, row?) => {
        return this.setCreateTime(val * 1000, "yyyy-MM-dd");
      },
    },
    expireTime: {
      format: (val, row?) => {
        return this.setCreateTime(val * 1000, "yyyy-MM-dd");
      },
    },
    endUseDate: {
      format: (val, row?) => {
        return this.setCreateTime(val * 1000, "yyyy-MM-dd");
      },
    },
    drivingStartUseDate: {
      format: (val, row?) => {
        if (val == 0 || val < 0) {
          return "";
        } else {
          return this.setCreateTime(val * 1000, "yyyy-MM-dd");
        }
      },
    },
    drivingEndUseDate: {
      format: (val, row?) => {
        if (val == 0 || val < 0) {
          return "";
        } else {
          return this.setCreateTime(val * 1000, "yyyy-MM-dd");
        }
      },
    },
    qualificationCertExpireTime: {
      format: (val, row?) => {
        return this.setCreateTime(val * 1000, "yyyy-MM-dd");
      },
    },
    noSignStatus: {
      format: (val, row?) => {
        return this.noSignStatus[val];
      },
      colorFormat: (val, row?) => {
        return StatusUtils.getSignStatus(val);
      },
    },
    signStatus: {
      format: (val, row?) => {
        return this.signStatus[val];
      },
      colorFormat: (val, row?) => {
        return StatusUtils.getSignStatus(val);
      },
    },
    signSource: {
      format: (val, row?) => {
        if (val) {
          return this.signSource[val];
        }
      },
    },
    signTime: {
      format: (val, row?) => {
        if (val) {
          return this.setCreateTime(val * 1000);
        }
      },
    },
    checkTime: {
      format: (val, row?) => {
        if (val) {
          return this.setCreateTime(val * 1000);
        }
      },
    },
    sjUserId: {
      format: (val, row?) => {
        return val > 0 ? "已关联" : "未关联";
      },
      colorFormat: (val, row?) => {
        return val > 0 ? "#00A600" : "#EA0000";
      },
    },
    createTime: {
      format: (val, row?) => {
        if (val) {
          return this.setCreateTime(val * 1000);
        }
      },
    },
    source: {
      format: (val, row?) => {
        return this.source[val];
      },
    },
    blacklistStatus: {
      format: (val, row?) => {
        if (val == 0) {
          return "否";
        } else {
          return "是";
        }
      },
    },
    reportStatus: {
      format: (val, row?) => {
        return this.reportStatus[val];
      },
      colorFormat: (val, row?) => {
        return StatusUtils.getReportStatus(val);
      },
    },
    openStatus: {
      format: (val, row?) => {
        return this.openStatus[val];
      },
      colorFormat: (val, row?) => {
        return StatusUtils.getOpenStatus(val);
      },
    },
    faceIdentifyStatus: {
      format: (val, row?) => {
        return this.faceIdentifyStatus[val];
      },
      colorFormat: (val, row?) => {
        return StatusUtils.getSignStatus(val);
      },
    },
  };
  updateColumnFlag = 1113343; // 是否更新当前列表数据标识，列表修改则必须修改此标识
  notPartKey =
    ",realname,name,checkName,checkFlag,checkTime,checkLog,useStatus,status,politicalOutlook,sex,birthDate,source,,startUseDate,endUseDate,drivingStartUseDate,drivingEndUseDate,signStatus,signSource,blacklistStatus,";
  keys = [
    // 列表for 拖拽
    { label: "司机姓名", key: "realname", show: true, fix: false, keyTyps: "detailLink", width: "150px" },
    { label: "司机账号", key: "mobilePhone", show: true, fix: false, width: "130px" },
    { label: "C端状态", key: "sjUserId", show: true, fix: false, width: "120px", keyTyps: "tag", format: true },
    { label: "已绑车辆", key: "truckCount", show: true, fix: false, width: "120px", keyTyps: "truckCount" },
    // { 'label': '会员等级', 'key': 'levelName', 'show': true, 'fix': false, 'width': '130px' },
    // { 'label': '会员生效日期', 'key': 'effectTime', 'show': true, 'fix': false, 'width': '130px', keyTyps: 'date'  },
    // { 'label': '会员到期日期', 'key': 'expireTime', 'show': true, 'fix': false, 'width': '130px', keyTyps: 'date'  },
    // { 'label': '业务员', 'key': 'saleUserName', 'show': true, 'fix': false, 'width': '160px' },
    // { 'label': '营业执照名称', 'key': 'businessName', 'show': true, 'fix': false, 'width': '160px' },
    // { 'label': '营业执照法人', 'key': 'businessLegalName', 'show': true, 'fix': false, 'width': '130px' },
    // { 'label': '统一社会信用代码', 'key': 'businessCertificate', 'show': true, 'fix': false, 'width': '190px' },
    // { 'label': '营业执照地址', 'key': 'businessCertificateAddress', 'show': true, 'fix': false, 'width': '180px' },
    // { 'label': '营业执照成立日期', 'key': 'businessCertificateEffectTime', 'show': true, 'fix': false, 'width': '130px' },
    // { 'label': '营业执照到期日期', 'key': 'businessCertificateExpireTime', 'show': true, 'fix': false, 'width': '130px' },
    // { 'label': '营业执照照片', 'key': 'businessCertificatePhoto', 'show': true, 'fix': false, 'width': '160px', keyTyps: 'icon' },
    { label: "审核状态", key: "checkFlag", show: true, keyTyps: "tag", format: true, width: "120px" },
    { label: "审核日志", key: "checkLog", show: true, fix: false, width: "200px" },
    { label: "上报状态", key: "reportStatus", show: true, format: true, fix: false, keyTyps: "tag", width: "110px" },
    { label: "开户状态", key: "openStatus", show: true, format: true, fix: false, keyTyps: "tag", width: "110px" },

    { label: "签署状态", key: "signStatus", show: true, fix: false, width: "120px", format: true, keyTyps: "tag" },
    // { 'label': '授权状态', 'key': 'noSignStatus', 'show': true, 'fix': false, 'width': '120px', format: true, keyTyps: 'tag' },
    { label: "人脸核验", key: "faceIdentifyStatus", show: true, fix: false, width: "120px", format: true, keyTyps: "detailTag" },
    { label: "证件过期", key: "certificateExpiredCount", show: true, fix: false, width: "120px", format: true, keyTyps: "certificateExpiredTag" },
    { label: "状态", key: "status", show: true, fix: false, keyTyps: "tag", format: true, width: "110px" },
    { label: "工作状态", key: "useStatus", show: true, fix: false, keyTyps: "tag", format: true, width: "110px" },
    { label: "政治面貌", key: "politicalOutlook", show: true, fix: false, format: true, colorFormat: true, width: "100px" },
    { label: "审核时间", key: "checkTime", show: true, fix: false, width: "180px", format: true },
    { label: "审核人", key: "checkName", show: true, fix: false, width: "160px" },
    { label: "手机号", key: "mobilePhone", show: true, fix: false, width: "130px" },
    { label: "身份证号码", key: "idCardNo", show: true, fix: false, width: "170px" },
    { label: "性别", key: "sex", show: true, format: true, colorFormat: true, width: "90px" },
    { label: "出生日期", key: "birthDate", show: true, width: "120px", format: true },
    { label: "地址", key: "address", show: true, width: "360px" },
    { label: "身份证有效期起", key: "startUseDate", show: true, fix: false, width: "120px", format: true },
    { label: "身份证有效期止", key: "endUseDate", show: true, fix: false, width: "180px", keyTyps: "endUseDateLink", format: true },
    { label: "准驾车型", key: "driverType", show: true, fix: false, format: true, width: "120px" },
    { label: "驾驶证有效日期始", key: "drivingStartUseDate", show: true, fix: false, width: "130px", format: true },
    { label: "驾驶证有效日期止", key: "drivingEndUseDate", show: true, fix: false, width: "180px", keyTyps: "drivingEndUseDateLink", format: true },
    { label: "从业资格证", key: "qualificationCertNo", show: true, fix: false, width: "130px" },
    { label: "从业资格证失效日期", key: "qualificationCertExpireTime", show: true, fix: false, width: "180px", keyTyps: "qualificationCertExpireTimeLink", format: true },
    { label: "签署来源", key: "signSource", show: true, fix: false, width: "120px", format: true },
    { label: "签署时间", key: "signTime", show: true, fix: false, width: "180px", format: true },
    { label: "是否黑名单", key: "blacklistStatus", show: true, fix: false, width: "120px", format: true },
    { label: "备注", key: "remark", show: true, fix: false, width: "180px" },
    { label: "来源", key: "source", show: true, fix: false, width: "120px", format: true },
    { label: "注册时间", key: "createTime", show: true, fix: false, width: "180px", format: true },
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public httpHelp: HttpHelpUtils,
    private el: ElementRef,
    private messageSub: MessageSub,
    private configSrv: ConfirmationService,
    private imagePreviewService: ImagePreviewService,
    private storage: LocalStorage,
    private ossFileService: OssFileService,
    private sanitizer: DomSanitizer,
  ) {
    super();
  }

  //新增司机关联
  selectedDriver = {}; //选择司机信息
  searchDriverList = []; //搜索结果集
  editAgentorRelDriver() {
    this.flag = 0;
    this.selectedDriver = {};
    this.validateRelDriverForm.reset();
    this.editIdCardDialogFlag = true;
  }
  /**
   * 计算传入日期与当前日期相差的天数
   * - 正数：传入日期在当前日期之后
   * - 负数：传入日期在当前日期之前
   * - 0：同一天
   * - ""：非法 / 空值
   */
  getDateDiffInDays(date?: string | number | null): number | "" {
    if (date == null || date === "") {
      return "";
    }

    let inputDate: Date;

    // 时间戳（number 或纯数字字符串）
    if (typeof date === "number" || /^\d+$/.test(String(date))) {
      const ts = typeof date === "number" ? date : Number(date);
      inputDate = new Date(ts);
    }
    // YYYY-MM-DD
    else if (/^\d{4}-\d{2}-\d{2}$/.test(String(date))) {
      const parts = String(date).split("-").map(Number);
      const y = parts[0];
      const m = parts[1] - 1; // JS 月份从 0 开始
      const d = parts[2];

      inputDate = new Date(y, m, d);

      // ✅ 拦截非法日期（如 2026-02-30 → 会被自动修正为 3月2日）
      if (inputDate.getFullYear() !== y || inputDate.getMonth() !== m || inputDate.getDate() !== d) {
        return "";
      }
    }
    // 不支持的格式
    else {
      return "";
    }

    if (Number.isNaN(inputDate.getTime())) {
      return "";
    }

    const now = new Date();
    now.setHours(0, 0, 0, 0);

    // 两个日期均为本地时区 00:00:00，无时区偏移问题
    return Math.floor((inputDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  }
  //新增区域合伙人关联
  selectedAgentDriver = {}; //选择司机信息
  searchAgentDriverList = []; //搜索结果集
  editAgentRelDriver() {
    this.selectedAgentDriver = {};
    this.validateRelAgentDriverForm.reset();
    this.editAgentDriverDialogFlag = true;
  }

  // 认证以及签署
  showAuthDialog = false;
  teamItem = {};
  authData(item) {
    this.httpHelp.loadingBlock = true;
    this.httpHelp.get("psg/fadada/user-auth", { dataId: item["id"], type: 1 }).then((res) => {
      console.log(res);
      if (res["status"] == this.svrType) {
        if (res["data"]["noSignStatus"] == 1) {
          // 未认证
          this.qCodeValue = res["data"]["userAuth"];
          this.showAuthDialog = true;
          this.httpHelp.loadingBlock = false;
        } else if (res["data"]["noSignStatus"] == 2) {
          // 已认证，未授权
          this.qCodeValue = res["data"]["freeSignSetUrl"];
          this.showAuthDialog = true;
          this.httpHelp.loadingBlock = false;
        } else if (res["data"]["noSignStatus"] == 3) {
          // 已授权，查看合同
          this.httpHelp.get("psg/fadada/free-sign", { dataId: item["id"], type: 1 }).then((signRes) => {
            this.httpHelp.loadingBlock = false;
            if (signRes["status"] == this.svrType) {
              var a = document.createElement("a");
              a.href = signRes["data"]["signUrl"];
              a.target = "_blank";
              a.click();
              a.remove();
            } else {
              this.showMessage(this.messageSub, signRes["message"], "error");
            }
          });
        }
      } else {
        this.httpHelp.loadingBlock = false;
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }
  handleReport(res) {}
  // 用户解除授权
  authUnbind(item) {
    const that = this;
    that.configSrv.confirm({
      message: "确定解除司机认证以及授权吗？",
      icon: "pi pi-exclamation-triangle",
      header: "解除确认",
      acceptLabel: "确定",
      rejectLabel: "取消",
      rejectButtonStyleClass: "p-button-raised p-button-text p-button-plain",
      accept: () => {
        this.httpHelp.loadingBlock = true;
        this.httpHelp.get("psg/fadada/user-unbind", { dataId: item["id"], type: 1 }).then((res) => {
          this.httpHelp.loadingBlock = false;
          if (res["status"] == this.svrType) {
            that.queryList(that.currentEvent);
          } else {
            that.showMessage(this.messageSub, res["message"], "error");
          }
        });
      },
      reject: () => {},
      key: "confirm",
    });
  }

  // 同步授权
  syncUserAuth() {
    let ids = "";
    this.selectedItem.forEach((item) => {
      ids += item.id + ",";
    });

    this.httpHelp.save({
      url: "psg/fadada/sync-user-auth",
      options: {
        ids: ids,
        type: 1, // 司机
      },
      confirm: this.configSrv,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] === this.svrType) {
          this.queryList();
          super.showMessage(this.messageSub, "授权同步成功！");
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      },
      successMsg: "授权同步成功！",
      confirmTitle: "同步授权确认",
      confirmMsg: "确认同步授权吗？",
    });
  }

  //保存关联司机信息
  async saveAgentorRelDriver() {
    // let tmpDriver = this.validateRelDriverForm.controls.driverId.value;
    // if(tmpDriver==null || tmpDriver==''){
    //   super.showMessage(this.messageSub,'请选择关联的司机信息！','error');
    //   return;
    // }

    let ids = "";
    if (this.flag == 0) {
      ids = this.tempId;
    } else {
      this.selectedItem.forEach((item) => {
        ids += item.id + ",";
      });
    }
    // this.selectedItem.forEach(item => {
    //     ids += item.id + ',';
    // });
    // if (ids == '') {
    //     ids = this.tempId
    // }

    const that = this;
    const options = {
      driverId: ids,
      shipperId: this.validateRelDriverForm.controls.cusId.value,
    };

    this.httpHelp.loadingBlock = true;
    await this.httpHelp
      .post("psg/drivers/add-shipper-drivers", options)
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] === this.svrType) {
          if (this.flag == 1) {
            this.dialogBlock = false;
            this.queryList();
          } else {
            that.queryRelDriver();
          }
          this.editIdCardDialogFlag = false;
          this.showMessage(this.messageSub, res["message"]);
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      })
      .catch((err) => {});
  }

  //删除关联司机
  delRelDriver() {
    let ids = "";
    const that = this;
    that.selectAgentorRelList.forEach((item) => {
      ids += item.id + ",";
    });
    this.httpHelp.delete({
      confirm: this.configSrv,
      url: "psg/drivers/delete-shipper-driver",
      deleteId: ids,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          that.queryRelDriver();
          that.showMessage(that.messageSub, res["message"]);
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      },
    });
  }

  //删除关联司机
  delAgentRelDriver() {
    let ids = "";
    const that = this;
    that.selectAgentRelList.forEach((item) => {
      ids += item.id + ",";
    });
    this.httpHelp.delete({
      confirm: this.configSrv,
      url: "psg/drivers/delete-agent-driver",
      deleteId: ids,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          that.queryRelAgentDriver();
          that.showMessage(that.messageSub, res["message"]);
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      },
    });
  }

  //保存关联司机信息
  async saveAgentRelDriver() {
    // let tmpDriver = this.validateRelDriverForm.controls.driverId.value;
    // if(tmpDriver==null || tmpDriver==''){
    //   super.showMessage(this.messageSub,'请选择关联的司机信息！','error');
    //   return;
    // }

    let ids = "";
    // this.selectedItem.forEach(item => {
    //     ids += item.id + ',';
    // });
    // if (ids == '') {
    //     ids = this.tempId
    // }
    if (this.flag == 0) {
      ids = this.tempId;
    } else {
      this.selectedItem.forEach((item) => {
        ids += item.id + ",";
      });
    }

    const that = this;
    const options = {
      driverId: ids,
      agentId: this.validateRelAgentDriverForm.controls.agentId.value,
    };

    this.httpHelp.loadingBlock = true;
    await this.httpHelp
      .post("psg/drivers/add-agent-drivers", options)
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] === this.svrType) {
          if (this.flag == 1) {
            this.dialogBlock = false;
            this.queryList();
          } else {
            that.queryRelAgentDriver();
          }
          this.editAgentDriverDialogFlag = false;
          this.showMessage(this.messageSub, res["message"]);
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      })
      .catch((err) => {});
  }

  cancelSave() {
    this.tempId = null;
    this.dialogBlock = false;
    this.editDialogFlag = false;
  }

  //已关联司机查询
  relDriverDialogFlag = false;
  dialogRelTitle = "";
  selectAgentorRelList = [];
  relAgentorDriverDataList = [];
  relDriversDialog(res) {
    this.tempId = res.id;
    this.dialogRelTitle = res.realname;
    this.queryRelDriver();
    this.relDriverDialogFlag = true;
  }

  relDriversDialog1() {
    this.flag = 1;
    this.selectedDriver = {};
    this.validateRelDriverForm.reset();
    this.editIdCardDialogFlag = true;
  }

  relDriverAgentDialogFlag = false;
  selectAgentRelList = [];
  relAgentDriverDataList = [];
  relAgentDriversDialog(res) {
    this.tempId = res.id;
    this.dialogRelTitle = res.realname;
    this.queryRelAgentDriver();
    this.relDriverAgentDialogFlag = true;
  }

  relAgentDriver() {
    this.flag = 1;
    this.selectedAgentDriver = {};
    this.validateRelAgentDriverForm.reset();
    this.editAgentDriverDialogFlag = true;
  }

  //查询车队长关联司机
  relDriverloading = false;
  queryRelDriver() {
    this.selectAgentorRelList = [];
    this.relAgentorDriverDataList = [];
    this.relDriverloading = true;
    this.httpHelp.get("psg/drivers/get-driver-rel-detail", { driverId: this.tempId }).then((res) => {
      this.relDriverloading = false;
      if (res["status"] === this.svrType) {
        this.relAgentorDriverDataList = res["data"]["relCusList"];
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  relAgentDriverloading = false;
  queryRelAgentDriver() {
    this.selectAgentRelList = [];
    this.relAgentDriverDataList = [];
    this.relAgentDriverloading = true;
    this.httpHelp.get("psg/drivers/get-driver-rel-detail", { driverId: this.tempId }).then((res) => {
      this.relAgentDriverloading = false;
      if (res["status"] === this.svrType) {
        this.relAgentDriverDataList = res["data"]["relAgentList"];
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  // -----------------------------------方法区--------------------------------------------------//
  changeTableList() {
    this.changeTable = !this.changeTable;
  }

  closeExamDialog() {
    this.showDriverCheckFlag = false;
    
  }
  handleChecked(){
    console.log("审核完毕")
  }
  // 切换查询状态
  changeSearchStatus(checkValue) {
    let that = this;
    this.statusItems.forEach((e) => {
      if (e.value === checkValue) {
        e.checkFlag = true;
      } else {
        e.checkFlag = false;
      }
    });
    this.searchForm.patchValue({
      checkFlag: checkValue,
    });
    this.queryList();
  }
  changeCertificateExpiredCountItems(checkValue) {
    let that = this;
    this.certificateExpiredCountItems.forEach((e) => {
      if (e.value === checkValue) {
        e.checkFlag = true;
      } else {
        e.checkFlag = false;
      }
    });
    this.searchForm.patchValue({
      certificateExpiredCount: checkValue,
    });
    this.queryList();
  }
  // 查询列表数据
  queryList(events?): void {
    const that = this;
    let httpOptions = {};
    for (const i in this.searchForm.controls) {
      httpOptions[i] = that.searchForm.controls[i].value;
    }
    if (events) {
      this.currentEvent = events;
      this.first = events["first"];
    } else {
      this.currentEvent = {
        first: 0,
        page: 0,
        rows: that.currentEvent["rows"] ? that.currentEvent["rows"] : that.defaultRows,
      };
    }
    httpOptions = {
      ...httpOptions,
      ...this.currentEvent,
    };
    that.loadingNum = 0;
    this.httpHelp.get("psg/drivers/page-drivers", httpOptions).then((res) => {
      if (res["status"] == this.svrType) {
        this.loadingNum = res["data"]["total"];
        if (that.loadingNum == 0) {
          this.emptyData = !this.emptyData;
        }
        that.listOfData = res["data"]["records"];
        that.totalNum = res["data"]["total"];
        that.first = that.currentEvent["first"];
        that.selectedItem = [];
        super.reloadScroll(this.el);
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  exportDialog = false;
  exportForm: FormGroup; // 导出
  // 导出弹窗
  exportCheckExcel() {
    this.exportForm.patchValue({
      exportTemplateType: 1,
    });
    this.exportDialog = true;
  }
  // 导出数据
  exportExcel() {
    const httpOptions = {};
    if (this.exportForm.get("exportTemplateType").value == 1) {
      for (const i in this.searchForm.controls) {
        httpOptions[i] = this.searchForm.controls[i].value;
      }
    } else if (this.exportForm.get("exportTemplateType").value == 2) {
      let ids = "";
      this.selectedItem.forEach((e) => {
        ids += e["id"] + ",";
      });
      httpOptions["ids"] = ids;
    }

    httpOptions["exportTemplateType"] = this.exportForm.get("exportTemplateType").value;
    this.httpHelp.loadingBlock = true;
    this.httpHelp.get("psg/drivers/export-driver-data", httpOptions).then((res) => {
      this.httpHelp.loadingBlock = false;
      if (res["status"] == this.svrType) {
        super.downFile(res["data"]["downFileUrl"], res["data"]["downFileName"]);
        this.exportDialog = false;
        this.dialogBlock = false;
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  uploadExcelFile: any = null; // 上传选择导入文件

  // 选择上传excel
  onSelectImportExcel(event) {
    this.uploadExcelFile = event["currentFiles"][0];
    this.basicfileUpload.nativeElement.click();
  }

  async saveImportExcelFile() {
    // 上传excel文件
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.cclnewuploadOSSFile(this.uploadExcelFile, this.regExUtils.IMPORTEXCEL).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.httpHelp.post("psg/drivers/import-data", { excelFileName: result["uploadName"], folder: this.regExUtils.IMPORTEXCEL }).then((res) => {
      this.httpHelp.loadingBlock = false;
      if (res["status"] == this.svrType) {
        this.queryList();
        this.dialogBlock = false;
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  // 导出表单
  chooseExcel() {
    this.uploadExcelFile = null;
    this.importDialog = true;
  }

  chooseTemplateExcel() {
    this.httpHelp.loadingBlock = true;
    this.httpHelp.get("psg/common/view-img", { folder: "template", imgName: "driverImport.xls" }).then((res) => {
      this.httpHelp.loadingBlock = false;
      if (res["status"] == this.svrType) {
        super.downFile(res["data"]["url"], "driverImport.xls");
        // this.exportDialog = false;
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  // 导入需要对账的运单数据
  importCheckExcel() {
    if (this.uploadExcelFile == null) {
      this.showMessage(this.messageSub, "请先选择需要导入的文件！", "error");
      return;
    }

    this.configSrv.confirm({
      message: "确定导入文件数据吗",
      icon: "pi pi-exclamation-triangle",
      header: "保存确认",
      acceptLabel: "确定",
      rejectLabel: "取消",
      rejectButtonStyleClass: "p-button-raised p-button-text p-button-plain",
      accept: () => {
        this.httpHelp.loadingBlock = true;
        this.saveImportExcelFile();
        this.importDialog = false;
      },
      reject: () => {},
      key: "confirm",
    });
  }

  //会员等级下拉框选中监听
  valueLevelChange(res) {
    let realPrice = "";
    this.levelList.forEach((e) => {
      if (e["value"] === res.value) {
        realPrice = e["price"];
      }
    });
    this.memberValidateForm.patchValue({
      realPrice,
    });
  }

  //展示成为会员弹框
  showAddMemberDialog(data) {
    const that = this;
    // that.selectedCrrentItem = data;
    this.tempId = data.id;
    this.memberValidateForm.reset();

    // var date=new Date('2024-06-28')
    // var time=date.getTime();
    // console.log("ssfds",time)
    this.memberValidateForm.patchValue({
      effectTime: this.setCreateTime(new Date(), "yyyy-MM-dd"),
    });
    // this.querySalesList(data)
    this.httpHelp.get("otAuth/member/level/list?status=0", {}).then((res) => {
      if (res["code"] == 0) {
        const list = res["data"];
        list.forEach((e) => {
          this.levelMap[e["id"]] = e["id"];
          this.levelList.push({
            label: e["name"],
            price: e["salePrice"],
            value: e["id"],
          });
        });
        // 点击请求成功显示会员框
        this.addMemberDialog = true;
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  //查询业务员列表接口
  querySalesList(data?) {
    this.httpHelp.get("system/sys/user/page-user?status=0&userLevel=2", {}).then((res) => {
      if (res["status"] === this.svrType) {
        const list = res["data"]["page"]["records"];
        list.forEach((e) => {
          this.salesmanList.push({
            label: e["realname"],
            value: e["id"],
          });
          this.saleUserNameList.push({
            label: e["realname"],
            value: e["id"],
          });
        });
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  //点击保存 执行成为会员接口
  addMemberLevel(data) {
    //组装参数
    const options = {
      ...data,
      id: this.tempId,
      levelId: this.memberValidateForm.get("level").value,
      saleUserId: this.memberValidateForm.get("salesman").value,
    };
    this.httpHelp.save({
      url: "otAuth/drivers/addLevel",
      options: options,
      validateForm: this.memberValidateForm,
      confirm: this.configSrv,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        this.addMemberDialog = false;
        //隐藏阴影背景
        this.dialogBlock = false;
        if (res["code"] === 0) {
          this.queryList();
          super.showMessage(this.messageSub, res["message"]);
        } else {
          super.showMessage(this.messageSub, res["msg"], "error");
        }
      },
      successMsg: "添加会员成功",
      confirmTitle: "提示",
      confirmMsg: "确定将该司机添加为会员吗？",
    });
  }

  insertTeam(data) {
    this.httpHelp.save({
      url: "psg/trucks/insert-team",
      options: data,
      confirm: this.configSrv,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] === this.svrType) {
          super.showMessage(this.messageSub, res["message"]);
          this.resetQuery();
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      },
      successMsg: "转为车主成功！",
      confirmTitle: "转用确认",
      confirmMsg: "是否转为车主？",
    });
  }

  // 编辑数据
  editRes(data?, type?): void {
    if (data) {
      this.tempId = data["id"];
      this.httpHelp.get("psg/common/get-form-token", {}).then((res) => {
        if (res["status"] == this.svrType) {
          this.formId = res["data"]["formId"];
          this.formToken = res["data"]["formToken"];
        } else {
        }
      });
      this.validateFormPhone.reset();
      this.queryDriver();
      let tempData = { ...data };
      this.validateForm.reset();
      this.editDialogType = type;
      this.validateForm.patchValue(tempData);
      if (tempData.politicalOutlook) {
        this.validateForm.controls.politicalOutlook.setValue(tempData.politicalOutlook + "");
      }
    } else {
      this.uploadFileUrl.drivingLicensePhotoUrl = "assets/file/image/business-photo.png";
      this.uploadFileUrl.idCardFrontUrl = "assets/file/image/id-card-front.png";
      this.uploadFileUrl.idCardBackUrl = "assets/file/image/id-card-back.png";
      this.tempId = null;
      this.validateForm.reset();
      this.validateFormPhone.reset();
      this.editDialogType = 1;
      this.id_card_no_front_url = "assets/file/image/sfzFront.png";
      this.editDriverIdCardDialogFlag = true;
    }
  }

  //验证司机身份证信息
  async identifyCard(event) {
    this.identifyIdCardFrontUrl = event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"];
    let result = {};
    // 上传司机证件
    this.httpHelp.loadingBlock = true;
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], this.regExUtils.ID_CARD).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.httpHelp
      .get("psg/common/analysis-img", {
        folder: this.regExUtils.ID_CARD,
        imgName: result["uploadName"],
        fileType: "id_card_front",
        vehicleType: "2",
      })
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          let idCardNo = res["data"]["analysisData"]["card"];
          let birthDate = "";
          let sex = 1;
          if (idCardNo != null && idCardNo != "") {
            if (idCardNo.length == 15) {
              birthDate = "19" + idCardNo.substr(6, 6);
            } else if (idCardNo.length == 18) {
              birthDate = idCardNo.substr(6, 8);
            }
            birthDate = birthDate.replace(/(.{4})(.{2})/, "$1-$2-");
            if (parseInt(idCardNo.substr(16, 1)) % 2 == 1) {
              sex = 1;
            } else {
              sex = 0;
            }
          }
          this.validateFormPhone.patchValue({
            idCardNo: res["data"]["analysisData"]["card"],
            address: res["data"]["analysisData"]["addr"],
            realname: res["data"]["analysisData"]["name"],
            sex: sex,
            birthDate: birthDate,
            idCardImgName: result["uploadName"],
          });
        } else {
          this.showMessage(this.messageSub, res["message"], "error");
        }
      });
  }

  // 审核司机
  checkDriver() {
    this.checkDriverForm.patchValue({
      checkFlag: 2,
      checkLog: "",
    });
    this.currentDriverCheckFlag = 2;
    this.checkDriverDialog = true;
  }

  currentDriverCheckFlag = 2;

  // 切换审核状态
  changeCheckStatus(status) {
    this.currentDriverCheckFlag = status;
  }

  //单条审核数据
  check(): void {
    const that = this;
    that.httpHelp.check({
      url: "psg/drivers/check-driversOne",
      deleteId: that.tempId,
      confirm: that.configSrv,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          this.showDriverCheckFlag = false;
          this.showMessage(this.messageSub, res["message"]);
          that.queryList();
        } else {
          this.showMessage(this.messageSub, res["message"], "error");
        }
      },
      confirmMsg: "是否确认审核通过？",
      confirmTitle: "确认审核",
    });
  }

  //审核不通过弹框
  checkLogSwitch = 0;
  check_waybill_noPass(data) {
    this.checkWaybillForm.reset();
    let tempData = { ...data };
    this.checkLogSwitch = 0;
    this.checkWaybillForm.patchValue({
      checkLogTips: "1",
      checkLog: "",
    });
    this.noCheckWaybillDialogFlag = true;
    this.httpHelp.get("psg/common/get-form-token", {}).then((res) => {
      if (res["status"] == this.svrType) {
        this.formToken = res["data"]["formToken"];
        this.formId = res["data"]["formId"];
        //this.editDialogFlag = true;
      } else {
        this.showMessage(this.messageSub, res["message"], "eoor");
      }
    });
  }
  //审核不通过理由
  checkLogTipsClick(val) {
    if (val == 4) {
      this.checkLogSwitch = 1;
    } else {
      this.checkLogSwitch = 0;
    }
  }
  //单条审核不通过
  noCheck(): void {
    const that = this;
    for (const i in that.checkWaybillForm.controls) {
      if (that.checkWaybillForm.controls[i].invalid) {
        that.checkWaybillForm.controls[i].markAsDirty();
        that.checkWaybillForm.controls[i].updateValueAndValidity();
        return;
      }
    }
    let checkLog = that.checkWaybillForm.controls.checkLog.value;
    let checkLogTips = that.checkWaybillForm.controls.checkLogTips.value;
    if (this.checkLogSwitch == 1) {
      if (checkLog == "" || checkLog == null) {
        super.showMessage(that.messageSub, "请填写其它原因！", "error");
        return;
      }
    } else {
      if (checkLogTips == 1) {
        that.checkWaybillForm.controls.checkLog.setValue("身份证正面照片模糊");
      } else if (checkLogTips == 2) {
        that.checkWaybillForm.controls.checkLog.setValue("身份证背面照片模糊");
      } else if (checkLogTips == 3) {
        that.checkWaybillForm.controls.checkLog.setValue("驾驶证照片模糊");
      } else if (checkLogTips == 5) {
        that.checkWaybillForm.controls.checkLog.setValue("证件不符");
      }
    }
    const options = {
      id: that.tempId,
      token: that.formToken,
      formId: that.formId,
      checkLog: that.checkWaybillForm.controls.checkLog.value,
    };
    that.httpHelp.loadingBlock = true;
    that.httpHelp.post("psg/drivers/noChecks-drivers", options).then((res) => {
      that.httpHelp.loadingBlock = false;
      if (res["status"] == that.svrType) {
        that.noCheckWaybillDialogFlag = false;
        that.showDriverCheckFlag = false;
        that.showMessage(that.messageSub, res["message"]);
        that.queryList();
      } else {
        that.showMessage(that.messageSub, res["message"], "error");
      }
    });
  }

  saveCheckDriver() {
    let flag = false;
    let ids = "";
    this.selectedItem.forEach((item) => {
      ids += item.id + ",";
      if (item.checkFlag != 1) {
        flag = true;
      }
    });
    if (this.currentDriverCheckFlag == 3 && this.checkDriverForm.get("checkLog").value == "") {
      this.showMessage(this.messageSub, "请填写审核备注", "error");
      return;
    }
    if (flag) {
      this.showMessage(this.messageSub, "选中数据中有已审核结束的数据，不能重复审核", "error");
      return;
    }
    this.httpHelp.save({
      confirm: this.configSrv,
      url: "psg/drivers/checks-drivers",
      options: {
        ids: ids,
      },
      validateForm: this.checkDriverForm,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          this.checkDriverDialog = false;
          this.queryList();
        } else {
          this.showMessage(this.messageSub, res["message"], "error");
        }
      },
    });
  }

  // 身份证自动上传识别
  onIdCardUpload(event) {
    this.httpHelp.loadingBlock = false;
    if (event.originalEvent["body"]) {
      const res = event.originalEvent["body"];
      if (res.status == this.svrType) {
        this.tempId = res["data"].id;
        this.validateFormPhone.patchValue({
          idCardNo: res["data"].idCardNo,
        });
      } else {
        this.showMessage(this.messageSub, res.message, "error");
      }
    }
  }

  // 查询司机是否存在
  queryDriver() {
    if (this.tempId == null && this.validateFormPhone.get("idCardNo").value == null) {
      this.showMessage(this.messageSub, "请上传身份证正面或者填写身份证号", "error");
      return;
    }
    let idCardNo = "";
    if (this.validateFormPhone.get("idCardNo").value != null) {
      idCardNo = this.validateFormPhone.get("idCardNo").value.replaceAll(" ", "");
    }

    this.editUploadFiles.id_card_no_front = "assets/file/image/sfzFront.png";
    this.editUploadFiles.id_card_no_back = "assets/file/image/sfzBack.png";
    this.editUploadFiles.driving_license_photo = "assets/file/image/driverLicense.png";
    this.editUploadFiles.qualification_cert_photo = "assets/file/image/driverLicense.png";
    this.httpHelp.loadingBlock = true;
    this.httpHelp
      .get("psg/drivers/get-id-card", {
        driverId: this.tempId,
        idCardNo: idCardNo,
        idCard: idCardNo,
      })
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        this.validateForm.reset();
        if (res["status"] === this.svrType) {
          this.editDialogFlag = true;
          this.idCardFrontUrl = "assets/file/image/id-card-front.png";
          this.idCardBackUrl = "assets/file/image/id-card-back.png";
          this.drivingLicensePhotoUrl = "assets/file/image/xsz.png";
          this.drivingLicenseBackPhotoUrl = "assets/file/image/xsz.png";
          this.qualificationCertPhotoUrl = "assets/file/image/xsz.png";
          if (res["data"]) {
            // 处理重复司机数据
            const driverItem = res["data"]["driver"];
            if (driverItem["birthDate"]) {
              driverItem["birthDate"] = this.setCreateTime(driverItem["birthDate"] * 1000, "yyyy-MM-dd");
            }
            if (driverItem["startUseDate"]) {
              driverItem["startUseDate"] = this.setCreateTime(driverItem["startUseDate"] * 1000, "yyyy-MM-dd");
            }
            if (driverItem["endUseDate"]) {
              driverItem["endUseDate"] = this.setCreateTime(driverItem["endUseDate"] * 1000, "yyyy-MM-dd");
            }
            if (driverItem["drivingStartUseDate"]) {
              driverItem["drivingStartUseDate"] = this.setCreateTime(driverItem["drivingStartUseDate"] * 1000, "yyyy-MM-dd");
            }
            if (driverItem["drivingEndUseDate"]) {
              driverItem["drivingEndUseDate"] = this.setCreateTime(driverItem["drivingEndUseDate"] * 1000, "yyyy-MM-dd");
            }
            if (driverItem["qualificationCertExpireTime"]) {
              driverItem["qualificationCertExpireTime"] = this.setCreateTime(driverItem["qualificationCertExpireTime"] * 1000, "yyyy-MM-dd");
            }
            this.validateForm.patchValue(driverItem);
            if (driverItem["driverType"] == null) {
              this.validateForm.patchValue({
                driverType: this.driverTypeList.length > 0 ? this.driverTypeList[0]["value"] : "",
              });
            }
            this.validateForm.patchValue({
              politicalOutlook: this.politicalOutlookLists.length > 0 ? this.politicalOutlookLists[0]["value"] : "",
              // driverType: this.driverTypeList.length > 0 ? this.driverTypeList[0]['value'] : ''
            });
            
            // 调试信息：打印原始数据
            console.log('=== 司机数据调试 ===');
            console.log('完整司机数据:', driverItem);
            console.log('从业资格证市级代码:', driverItem["qualificationCertIssueAreaCode"]);
            
            // 如果存在从业资格证颁发机构所在地（市），则提取省份并加载对应的市列表
            if (driverItem["qualificationCertIssueAreaCode"]) {
              const cityCode = driverItem["qualificationCertIssueAreaCode"];
              // 从市级代码提取省份代码（前2位+4个0，如130200 -> 130000）
              const provinceCode = cityCode.substring(0, 2) + "0000";
              
              console.log('=== 省市回填调试 ===');
              console.log('市级代码:', cityCode);
              console.log('提取的省份代码:', provinceCode);
              console.log('当前省份列表长度:', this.insProvinceList.length);
              console.log('当前省份列表:', this.insProvinceList);
              
              // 检查省份列表中是否有匹配的选项
              const matchedProvince = this.insProvinceList.find(item => item.value === provinceCode);
              console.log('省份列表中匹配的选项:', matchedProvince);
              if (!matchedProvince) {
                console.error('警告：省份列表中没有找到省份代码:', provinceCode);
              }
              
              // 先确保省份列表已加载
              const loadProvinceAndCity = () => {
                console.log('开始加载省市数据');
                
                // 直接使用API加载城市列表（参考agent_all_trucks_detail的实现）
                this.httpHelp
                  .get("psgsys/sj/areainfo/getAreaList?pAreaCode=" + provinceCode + "&provinceName=", {})
                  .then((res) => {
                    console.log('城市列表API响应:', res);
                    
                    if (res["code"] === 0) {
                      // 关键：在城市列表加载完成后，构建城市列表并设置省份和城市值
                      this.insCityList = [
                        {
                          label: "--请选择--",
                          value: "",
                        },
                      ];
                      const list = res["data"];
                      list.forEach((e) => {
                        this.insCityList.push({
                          label: e["areaName"],
                          value: e["areaCode"],
                        });
                      });
                      
                      console.log('构建完成的城市列表:', this.insCityList);
                      
                      // 检查城市列表中是否有匹配的选项
                      const matchedCity = this.insCityList.find(item => item.value === cityCode);
                      console.log('城市列表中匹配的选项:', matchedCity);
                      if (!matchedCity) {
                        console.error('警告：城市列表中没有找到城市代码:', cityCode);
                      }
                      
                      // 在城市列表构建完成后，设置表单值
                      // 关键：需要转换为Number类型
                      this.validateForm.patchValue({
                        insureProvince: Number(provinceCode),
                        qualificationCertIssueAreaCode: Number(cityCode)
                      });
                      
                      console.log('最终表单值:', this.validateForm.value);
                      console.log('insureProvince控件值:', this.validateForm.get('insureProvince')?.value);
                      console.log('qualificationCertIssueAreaCode控件值:', this.validateForm.get('qualificationCertIssueAreaCode')?.value);
                      
                      // 强制Angular检测变化
                      setTimeout(() => {
                        console.log('延迟后再次检查表单值:', this.validateForm.value);
                      }, 500);
                    } else {
                      console.error('加载城市列表失败:', res["message"]);
                    }
                  })
                  .catch(err => {
                    console.error('加载城市列表异常:', err);
                  });
              };
              
              // 检查省份列表是否已加载
              if (this.insProvinceList.length <= 1) {
                console.log('省份列表为空，需要先加载省份列表');
                // 加载省份列表
                this.httpHelp
                  .get("psgsys/sj/areainfo/getAreaList?pAreaCode=0&provinceName=", {})
                  .then((res) => {
                    console.log('省份列表API响应:', res);
                    if (res["code"] === 0) {
                      this.insProvinceList = [
                        {
                          label: "--请选择--",
                          value: "",
                        },
                      ];
                      const list = res["data"];
                      list.forEach((e) => {
                        this.insProvinceList.push({
                          label: e["areaName"],
                          value: e["areaCode"],
                        });
                      });
                      console.log('构建完成的省份列表:', this.insProvinceList);
                      
                      // 省份列表加载完成后，再加载城市
                      loadProvinceAndCity();
                    }
                  })
                  .catch(err => {
                    console.error('加载省份列表异常:', err);
                  });
              } else {
                console.log('省份列表已存在，直接加载城市');
                loadProvinceAndCity();
              }
            } else {
              console.log('qualificationCertIssueAreaCode 为空，跳过省市处理');
            }
            
            // 查询预览图片
            if (driverItem.idCardNoFront) {
              this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, driverItem.idCardNoFront, 2).then((res) => {
                if (res["status"] == this.svrType) {
                  this.idCardFrontUrl = res["data"]["url"];
                }
              });
            }
            if (driverItem.idCardNoBack) {
              this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, driverItem.idCardNoBack, 2).then((res) => {
                if (res["status"] == this.svrType) {
                  this.idCardBackUrl = res["data"]["url"];
                }
              });
            }
            if (driverItem.drivingLicensePhoto) {
              this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, driverItem.drivingLicensePhoto, 2).then((res) => {
                if (res["status"] == this.svrType) {
                  this.drivingLicensePhotoUrl = res["data"]["url"];
                }
              });
            }
            if (driverItem.drivingLicenseBackPhoto) {
              this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, driverItem.drivingLicenseBackPhoto, 2).then((res) => {
                if (res["status"] == this.svrType) {
                  this.drivingLicenseBackPhotoUrl = res["data"]["url"];
                }
              });
            }
            if (driverItem.qualificationCertPhoto) {
              this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, driverItem.qualificationCertPhoto, 2).then((res) => {
                if (res["status"] == this.svrType) {
                  this.qualificationCertPhotoUrl = res["data"]["url"];
                }
              });
            }
          } else {
            // 无司机数据
            if (this.identifyIdCardFrontUrl != "assets/file/image/sfzFront.png") {
              const driverItem = {
                realname: this.validateFormPhone.get("realname").value,
                idCardNo: this.validateFormPhone.get("idCardNo").value,
                address: this.validateFormPhone.get("address").value,
                sex: this.validateFormPhone.get("sex").value,
                birthDate: this.validateFormPhone.get("birthDate").value,
                idCardNoFront: this.validateFormPhone.get("idCardImgName").value,
                sjUserId: this.validateFormPhone.get("sjUserId").value,
                politicalOutlook: this.politicalOutlookLists.length > 0 ? this.politicalOutlookLists[0]["value"] + "" : "",
                driverType: this.driverTypeList.length > 0 ? this.driverTypeList[0]["value"] + "" : "",
              };
              // 获取司机证件预览图片
              this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, this.validateFormPhone.get("idCardImgName").value).then((res) => {
                if (res["status"] == this.svrType) {
                  this.idCardFrontUrl = res["data"]["url"];
                } else {
                  this.showMessage(this.messageSub, res["message"], "error");
                }
              });
              this.validateForm.patchValue(driverItem);
            } else {
              const driverItem = {
                idCardNo: this.validateFormPhone.get("idCardNo").value,
                sjUserId: this.validateFormPhone.get("sjUserId").value,
              };
              this.validateForm.patchValue(driverItem);
            }
          }
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      });
  }

  // 搜索C端手机号
  searchMobilePhone(event) {
    const that = this;
    const httpOptions = { custType: 1, userPhone: event.filter };

    const currentEvent = {
      first: 1,
      pageNo: 1,
      pageSize: 30,
    };

    that.loadingNum = 0;
    that.httpHelp
      .get("psgsys/sjUser/page", {
        ...httpOptions,
        ...currentEvent,
      })
      .then((res) => {
        if (res["code"] == 0) {
          this.mobilePhoneList = res["data"]["list"].map((item) => {
            return {
              ...item,
              label: item.userPhone,
              value: item.id,
            };
          });
        } else {
          this.showMessage(this.messageSub, res["msg"], "error");
        }
      });
  }

  // 编辑司机选择证件
  async onSelectDriverCard(event, cardType) {
    if (cardType == "id_card_no_front") {
      this.id_card_no_front_url = event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"];
      this.editUploadFiles.id_card_no_front = event["files"][0];
    } else if (cardType == "id_card_no_back") {
      // 选择身份证背面
      this.id_card_no_back_url = event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"];
      this.editUploadFiles.id_card_no_back = event["files"][0];
    } else if (cardType == "driving_license_photo") {
      // 选择驾驶证
      this.driving_license_photo_url = event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"];
      this.editUploadFiles.driving_license_photo = event["files"][0];
    }
  }

  // 保存司机信息
  async saveDriverInfo() {
    // if (this.validateFormPhone.get('idCardImgName').value) {
    //     this.validateForm.patchValue({
    //         idCardNoFront: this.validateFormPhone.get('idCardImgName').value
    //     });
    // } else { // 判断是否是修改过的图片
    //     if (this.editUploadFiles.id_card_no_front != '') {

    //     }
    // }
    const that = this;
    let url = "add-drivers";
    if (that.tempId) {
      url = "update-drivers";
    }
    const options = {
      id: that.tempId,
      token: this.formToken,
      formId: this.formId,
    };
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls[i].invalid) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
        return;
      } else {
        options[i] = this.validateForm.get(i).value;
      }
    }
    if (options["mobilePhone"] != "" || options["mobilePhone"] != null) {
      options["mobilePhone"] = options["mobilePhone"].replaceAll(" ", "");
    }
    if (options["idCardNo"] != "" || options["idCardNo"] != null) {
      options["idCardNo"] = options["idCardNo"].replaceAll(" ", "");
    }
    await this.httpHelp
      .post("psg/drivers/" + url, options)
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] === this.svrType) {
          that.queryList();
          that.editDialogFlag = false;
          that.editDriverIdCardDialogFlag = false;
          this.dialogBlock = false;
          super.showMessage(this.messageSub, res["message"]);
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      })
      .catch((err) => {});
  }

  //驾驶证
  async onSelectBusiness(event) {
    this.drivingLicensePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], this.regExUtils.ID_CARD).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.drivingLicensePhotoInput.nativeElement.click();
    this.httpHelp
      .get("psg/common/analysis-img", {
        folder: this.regExUtils.ID_CARD,
        imgName: result["uploadName"],
        fileType: "driving_licence",
        vehicleType: "2",
      })
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          let validateDate = ""; //驾驶证有效期起
          let expire = ""; //驾驶证有效期止
          let signGroup = ""; //发证机关
          let driveType = this.driverTypeList[0]["value"]; //准驾车型
          let num = ""; //驾驶证号
          if (res["data"] != null && res["data"] != "") {
            num = res["data"]["analysisData"]["num"];
            let idCardNo = this.validateForm.controls.idCardNo.value;
            if (idCardNo == "" || idCardNo == null) {
              this.showMessage(this.messageSub, "请先上传身份证照片！", "error");
              return;
            } else {
              if (idCardNo != num) {
                this.showMessage(this.messageSub, "请核实驾驶证是否所属该司机！", "warn");
              }
            }
            validateDate = res["data"]["analysisData"]["validateDate"];
            if (validateDate != "长期") {
              if (validateDate != undefined && validateDate.length == 8) {
                validateDate = validateDate.replace(/(.{4})(.{2})/, "$1-$2-");
              } else {
                validateDate = "";
              }
            }

            expire = res["data"]["analysisData"]["expire"];
            if (validateDate == "长期") {
              expire = "2099-12-31";
              validateDate = "";
            } else {
              if (expire.indexOf("年") > 0) {
                try {
                  let tmpExpire = expire.replace("年", "");
                  if (validateDate) {
                    let date = new Date(validateDate);
                    let year = date.getFullYear() + parseInt(tmpExpire);
                    let month = date.getMonth();
                    let day = date.getDate();
                    expire = year + "-" + (month + 1 > 9 ? month + 1 : "0" + (month + 1)) + "-" + (day > 9 ? day : "0" + day);
                  }
                } catch (e) {
                  expire = "";
                }
              } else {
                if (expire != undefined && expire.length == 8) {
                  expire = expire.replace(/(.{4})(.{2})/, "$1-$2-");
                } else {
                  if (expire == "长期") {
                    expire = "2099-12-31";
                  } else {
                    expire = "";
                  }
                }
              }
            }
            signGroup = res["data"]["analysisData"]["signGroup"];
            driveType = res["data"]["analysisData"]["driveType"];
            if (driveType == "" || driveType == null) {
              driveType = this.driverTypeList[0]["value"];
            }
          } else {
            this.validateForm.patchValue({
              drivingLicensePhoto: result["uploadName"],
            });
            this.showMessage(this.messageSub, "未识别到驾驶证信息，请检查照片是否清晰！", "error");
            return;
          }
          this.validateForm.patchValue({
            driverType: driveType,
            drivingStartUseDate: validateDate,
            drivingEndUseDate: expire,
            issuingOrganizations: signGroup,
            drivingLicensePhoto: result["uploadName"],
          });
        } else {
          this.validateForm.patchValue({
            drivingLicensePhoto: result["uploadName"],
          });
          this.showMessage(this.messageSub, res["message"] + "请检查照片是否清晰！", "error");
        }
      });
    this.editUploadFiles.driving_license_photo = this.drivingLicensePhotoUrl;
  }

  //上传司机从业资格证
  async onSelectQualificationCert(event) {
    this.qualificationCertPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], this.regExUtils.ID_CARD).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.qualificationCertPhotoInput.nativeElement.click();
    this.httpHelp.loadingBlock = false;
    this.validateForm.patchValue({
      qualificationCertPhoto: result["uploadName"],
    });
    this.editUploadFiles.qualification_cert_photo = this.qualificationCertPhotoUrl;
  }

  //驾驶证副页
  async onSelectDrivingLicenseBack(event) {
    this.drivingLicenseBackPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], this.regExUtils.ID_CARD).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.drivingLicenseBackPhotoInput.nativeElement.click();
    this.httpHelp.loadingBlock = false;
    this.validateForm.patchValue({
      drivingLicenseBackPhoto: result["uploadName"],
    });
    this.editUploadFiles.driving_license_back_photo = this.drivingLicenseBackPhotoUrl;
  }


  // 选择身份证，并识别
  async onSelectIdcard(event) {
    this.idCardFrontUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    let result = {};
    // 上传司机证件
    this.httpHelp.loadingBlock = true;
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], this.regExUtils.ID_CARD).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.idCardFrontInput.nativeElement.click();
    this.httpHelp
      .get("psg/common/analysis-img", {
        folder: this.regExUtils.ID_CARD,
        imgName: result["uploadName"],
        fileType: "id_card_front",
        vehicleType: "2",
      })
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          let idCardNo = res["data"]["analysisData"]["card"];
          let birthDate = "";
          let sex = 1;
          if (idCardNo != null && idCardNo != "") {
            if (idCardNo.length == 15) {
              birthDate = "19" + idCardNo.substr(6, 6);
            } else if (idCardNo.length == 18) {
              birthDate = idCardNo.substr(6, 8);
            }
            birthDate = birthDate.replace(/(.{4})(.{2})/, "$1-$2-");
            if (parseInt(idCardNo.substr(16, 1)) % 2 == 1) {
              sex = 1;
            } else {
              sex = 0;
            }
          }
          this.validateForm.patchValue({
            idCardNo: res["data"]["analysisData"]["card"],
            address: res["data"]["analysisData"]["addr"],
            realname: res["data"]["analysisData"]["name"],
            sex: sex,
            birthDate: birthDate,
            idCardNoFront: result["uploadName"],
          });
        } else {
          this.showMessage(this.messageSub, res["message"], "error");
        }
      });
    this.editUploadFiles.id_card_no_front = this.idCardFrontUrl;
  }

  // 选择身份证背面
  async onSelectIdCardBack(event) {
    this.idCardBackUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    let result = {};
    // 上传司机证件
    this.httpHelp.loadingBlock = true;
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], this.regExUtils.ID_CARD).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.idCardBackInput.nativeElement.click();
    this.httpHelp
      .get("psg/common/analysis-img", {
        folder: this.regExUtils.ID_CARD,
        imgName: result["uploadName"],
        fileType: "id_card_back",
        vehicleType: "2",
      })
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          let signDate = res["data"]["analysisData"]["signDate"];
          if (signDate.length == 8 && signDate != undefined) {
            signDate = signDate.substring(0, 4) + "-" + signDate.substring(4, 6) + "-" + signDate.substring(6, 8);
          } else {
            signDate = "";
          }
          let expire = res["data"]["analysisData"]["expire"];
          if (expire.length == 8 && expire != undefined) {
            expire = expire.substring(0, 4) + "-" + expire.substring(4, 6) + "-" + expire.substring(6, 8);
          } else {
            if (expire == "长期") {
              expire = "2099-12-31";
            } else {
              expire = "";
            }
          }
          this.validateForm.patchValue({
            startUseDate: signDate,
            endUseDate: expire,
            idCardNoBack: result["uploadName"],
          });
        } else {
          this.showMessage(this.messageSub, res["message"] + "请检查照片是否清晰！", "error");
        }
      });
    this.editUploadFiles.id_card_no_back = this.idCardBackUrl;
  }

  // 保存编辑
  save() {
    if (this.idCardBackUrl == "assets/file/image/id-card-back.png") {
      this.showMessage(this.messageSub, "请上传身份证国徽面照片", "error");
      return;
    }
    if (this.idCardFrontUrl == "assets/file/image/id-card-back.png") {
      this.showMessage(this.messageSub, "请上传身份证背面照片", "error");
      return;
    }
    if (this.drivingLicensePhotoUrl == "assets/file/image/xsz.png") {
      this.showMessage(this.messageSub, "请上传驾驶证照片", "error");
      return;
    }
    if (this.drivingLicenseBackPhotoUrl == "assets/file/image/xsz.png") {
      this.showMessage(this.messageSub, "请上传驾驶证副页照片", "error");
      return;
    }

    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls[i].invalid) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
        return;
      }
    }
    // 验证表单
    let mobilePhone = this.validateForm.controls.mobilePhone.value;
    if (mobilePhone != "" || mobilePhone != null) {
      mobilePhone = mobilePhone.replaceAll(" ", "");
    }
    if (!this.regExUtils.PHONE_NUMBER_RULE.test(mobilePhone)) {
      this.showMessage(this.messageSub, "手机号码有误，请重填", "error");
      return;
    }
    let idCardNo = this.validateForm.controls.idCardNo.value;
    if (idCardNo != "" || idCardNo != null) {
      idCardNo = idCardNo.replaceAll(" ", "");
    }
    if (!this.regExUtils.ID_CARD_NO_RULE.test(idCardNo)) {
      this.showMessage(this.messageSub, "身份证号有误，请重填", "error");
      return;
    }
    this.configSrv.confirm({
      message: "确定保存司机信息吗",
      icon: "pi pi-exclamation-triangle",
      header: "保存确认",
      acceptLabel: "确定",
      rejectLabel: "取消",
      rejectButtonStyleClass: "p-button-raised p-button-text p-button-plain",
      accept: () => {
        this.httpHelp.loadingBlock = true;
        this.saveDriverInfo();
      },
      reject: () => {},
      key: "confirm",
    });
  }

  // 显示司机详情
  showDriverDetail(item) {
    item.driverId = item.id;
    this.driverDetail = item;
    this.showDriverFlag = true;
  }

  // 删除数据
  delete(): void {
    let ids = "";
    const that = this;
    this.selectedItem.forEach((item) => {
      ids += item.id + ",";
    });
    this.httpHelp.delete({
      confirm: this.configSrv,
      url: "psg/drivers/delete-drivers",
      deleteId: ids,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          that.queryList();
        } else {
          that.showMessage(this.messageSub, res["message"], "error");
        }
      },
    });
  }

  // 设置上传数据
  setUploadData(event) {
    event.formData.append("driver_id", this.operateDriverItem["id"]);
    event.formData.append("upload_type", this.uploadCurrentType);
  }

  // 选择上传类型
  chooseUpload(item) {
    this.dialogTitle = item["uploadFileTitle"];
    this.dialogSubTitle = this.operateDriverItem["realname"];
    this.uploadCurrentType = item["uploadType"];
    this.uploadCommonDialog = true;
  }

  //身份证正面照片识别转换
  onUpload(event) {
    this.httpHelp.loadingBlock = false;
    if (event.originalEvent["body"]) {
      const res = event.originalEvent["body"];
      if (res.status === this.svrType) {
        this.uploadCommonDialog = false;
      } else {
        this.showMessage(this.messageSub, res.message, "error");
      }
    }
  }

  fddSignFlag = false;
  fddDetail = {};
  // 打开签署方式
  signContract(item) {
    // if (item.signStatus == 2) {
    // this.showFadadaDriverAgree(item)
    // } else {
    this.tempId = item["id"];
    this.signContractForm.patchValue({
      signContract: 1,
    });
    this.signContractDialog = true;
    // }

    this.httpHelp.get("psg/fadada/get-fddSign", { type: 1, dataId: item.id }).then((res) => {
      if (res["status"] == "success") {
        if (res["data"] == null) {
          this.fddSignFlag = false;
        } else {
          this.fddDetail["signStatus"] = res["data"]["fddsign"]["signStatus"];
          this.fddDetail["createTime"] = res["data"]["fddsign"]["createTime"];
          this.fddDetail["contractNo"] = res["data"]["fddsign"]["contractNo"];
          this.fddDetail["realname"] = item.realname;
          if (this.fddDetail["signStatus"] > 0) {
            this.fddSignFlag = true;
          }
        }
      } else {
        // this.showMessage()
      }
    });
  }

  qCodeValue = "";
  elementType = NgxQrcodeElementTypes.IMG;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;

  // 签署委托代征
  saveSignContract() {
    const that = this;
    // 签署方式
    // if (that.signContractForm.get('signContract').value == 1) {
    //     that.qCodeValue = environment.qCodeUrl + 'psgsys/psg/fadada/get-fdd-sign-url';
    //     that.showQCodeFlag = true;
    //     return;
    // }

    this.httpHelp.save({
      confirm: this.configSrv,
      url: "psg/fadada/send_sign-msg",
      options: {
        signObjType: 1, // 1:司机签署，2：车主签署
        signObjId: that.tempId,
        signSource: 1, // 1:网页签署，2：小程序签署,
        signType: 1, // 1:委托代征签署，2：代收协议签署
        sjId: that.tempId,
      },
      validateForm: that.signContractForm,
      success: (res) => {
        that.httpHelp.loadingBlock = false;
        this.signContractDialog = false;
        if (res["status"] == that.svrType) {
          //
          if (that.signContractForm.get("signContract").value == 1) {
            that.qCodeValue = environment.qCodeUrl + "psgsys/psg/fadada/get-fdd-sign-url?code=" + res["data"]["signCode"];
            that.showQCodeFlag = true;
            this.signContractDialog = false;

            return;
          }
          this.dialogBlock = false;
        } else {
          this.signContractDialog = false;
          that.showMessage(that.messageSub, res["message"], "error");
        }
      },
      successMsg: "确认签署吗？",
    });
  }

  // ==========================银行卡开始==========================
  driverId = "";
  myBankRes(data) {
    this.tempId = data["id"];
    this.dialogSubTitle = data["realname"];
    this.idCodeNo = data["idCardNo"];
    this.myBank["myBnakListDialogFlag"] = true;
    this.driverId = data["id"];
    this.queryMyBanckCard();
  }

  // 编辑数据
  editMyBankCard() {
    this.bankForceBindStatus = 0;
    this.myBank["bankPhotoUrl"] = "assets/file/image/pho_yinhangka@2x.png";
    this.validateBankForm.reset();
    this.smsCountDown = 0;
    if (this.smsTimer) {
      clearInterval(this.smsTimer);
      this.smsTimer = null;
    }
    this.myBank["editMyBankDialogFlag"] = true;
  }

  getBankPhoneVerifyCode() {
    const phoneControl = this.validateBankForm.get("bankReservePhone");
    let phone = phoneControl && phoneControl.value ? phoneControl.value.toString().replaceAll(" ", "") : "";
    if (!phone || !this.regExUtils.PHONE_NUMBER_RULE.test(phone)) {
      this.showMessage(this.messageSub, "手机号码有误，请重填", "error");
      return;
    }
    if (this.smsCountDown > 0) {
      return;
    }
    this.httpHelp.loadingBlock = true;
    this.httpHelp
      .get("psgsys/sj/nj/xin/verify-phone", { phone: phone })
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["code"] == 0) {
          this.showMessage(this.messageSub, res["message"] || "验证码已发送");
          this.startSmsCountdown();
        } else {
          this.showMessage(this.messageSub, res["message"] || "获取验证码失败", "error");
        }
      })
      .catch(() => {
        this.httpHelp.loadingBlock = false;
        this.showMessage(this.messageSub, "获取验证码失败", "error");
      });
  }

  startSmsCountdown() {
    this.smsCountDown = 60;
    if (this.smsTimer) {
      clearInterval(this.smsTimer);
    }
    this.smsTimer = window.setInterval(() => {
      if (this.smsCountDown <= 1) {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
        this.smsCountDown = 0;
        return;
      }
      this.smsCountDown -= 1;
    }, 1000);
  }

  // 删除银行卡
  delMyCardBank() {
    let ids = "";
    const that = this;
    that.myBank["selectedBankList"].forEach((item) => {
      ids += item.id + ",";
    });
    this.httpHelp.delete({
      confirm: this.configSrv,
      url: "psg/drivers/delete-bankAccount",
      deleteId: ids,
      success: (res) => {
        that.httpHelp.loadingBlock = false;
        if (res.status == this.svrType) {
          that.myBank["selectedBankList"] = [];
          this.queryMyBanckCard();
        } else {
          super.showMessage(this.messageSub, res.message, "error");
        }
      },
    });
  }

  //银行卡三要素认证
  checkBankCardLegel() {
    const that = this;
    this.bankCardNo = this.validateBankForm.get("accountNo").value;
    for (;;) {
      if (this.bankCardNo.split(" ").length > 2) {
        this.bankCardNo = this.bankCardNo.replace(" ", "");
      } else {
        break;
      }
      if (this.bankCardNo.split("_").length > 0) {
        this.bankCardNo = this.bankCardNo.replace("_", "");
      } else {
        break;
      }
    }
    let options = {
      idCardNum: this.idCodeNo,
      // bankCardNo:this.bankCardNo,
      bankCardNo: this.bankCardNo.replace(" ", ""),
      name: this.dialogSubTitle,
      cardType: this.validateBankForm.get("bankName").value,
    };
    this.httpHelp.loadingBlock = true;
    this.httpHelp.post("psg/common/check-bank-card", options).then((res) => {
      this.httpHelp.loadingBlock = false;
      if (res["status"] == this.svrType) {
        if (res["code"] == 2) {
          that.showMessage(that.messageSub, res["message"], "error");
          return;
        }
        if (res["data"]["status"] == "fail") {
          this.bankForceBindStatus = 1; //信息不匹配是，开启强制绑卡按钮
          that.showMessage(that.messageSub, res["data"]["message"], "error");
          return;
        }
        that.saveMyCardBank("0");
      } else {
        that.showMessage(that.messageSub, res["message"], "error");
      }
    });
  }

  // 保存银行卡
  saveMyCardBank(force) {
    const that = this;
    let phone = this.validateBankForm.get("bankReservePhone")?.value ? this.validateBankForm.get("bankReservePhone").value.toString().replaceAll(" ", "") : "";
    let options = {
      objNo: this.idCodeNo,
      objName: this.dialogSubTitle,
      isForce: force,
      bankImg: this.validateBankForm.get("bankImg").value,
      accountNo: this.bankCardNo.replace(" ", ""),
      cardType: this.validateBankForm.get("bankName").value,
      bankReservePhone: phone,
      validateNum: this.validateBankForm.get("validateNum").value,
      driverId: this.driverId,
    };
    this.httpHelp.loadingBlock = false;
    that.httpHelp.save({
      confirm: this.configSrv,
      url: "psg/drivers/add-bankAccount",
      options: options,
      // validateForm: that.validateBankForm,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        if (res.status == this.svrType) {
          that.myBank["editMyBankDialogFlag"] = false;
          that.queryMyBanckCard();
          that.showMessage(that.messageSub, res["message"]);
        } else {
          that.showMessage(that.messageSub, res.message, "error");
        }
      },
    });
  }

  // 查询我的银行卡
  loading = false;
  queryMyBanckCard() {
    const that = this;
    that.loading = true;
    this.httpHelp.get("psg/drivers/page-bankAccount", { objNo: that.idCodeNo }).then((res) => {
      that.loading = false;
      if ((res["status"] = this.svrType)) {
        that.myBank["bankDataList"] = res["data"];
      } else {
        super.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  // 选择我的银行卡
  async onSelectBankCard(event) {
    this.myBank["bankPhotoUrl"] = event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"];
    let result = {};
    // 上传司机证件
    this.httpHelp.loadingBlock = true;
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], this.regExUtils.BANK_CARD).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.editUploadInput.nativeElement.click();
    this.httpHelp
      .get("psg/common/analysis-img", {
        folder: this.regExUtils.BANK_CARD,
        imgName: result["uploadName"],
        fileType: "bank_card",
        vehicleType: "2",
      })
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          if (res["data"]["analysisData"]["bank_card_number"] == "" || res["data"]["analysisData"]["bank_card_number"] == null) {
            this.showMessage(this.messageSub, "未识别到银行卡，请检查银行卡照片！", "error");
            return;
          }
          this.validateBankForm.patchValue({
            accountNo: res["data"]["analysisData"]["bank_card_number"],
            bankImg: result["uploadName"],
            bankName: res["data"]["analysisData"]["bank_name"],
          });
        } else {
          this.showMessage(this.messageSub, res["message"], "error");
        }
      });
  }

  // ==========================银行卡结束==========================

  // ===========================我的车辆===========================
  // 我的车辆
  myCardRes(data) {
    this.tempId = data["id"];
    this.dialogSubTitle = data["realname"];
    this.commonGetDriverList();
  }

  commonGetDriverList() {
    const that = this;
    this.truckValidateForm.reset();
    this.httpHelp.loadingBlock = true;
    this.httpHelp.get("psg/drivers/page-drivers-truck", { driverId: that.tempId }).then((res) => {
      this.httpHelp.loadingBlock = false;
      if (res["status"] === this.svrType) {
        that.myTruck["trucksDataList"] = res["data"];
        that.myTruck["selectedTruckList"] = [];
        this.myTruck["myTruckListDialogFlag"] = true;
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  driverTruckList() {
    const that = this;
    this.httpHelp.loadingBlock = true;
    let plateNumber = this.truckValidateForm.get("plateNumber").value;
    this.httpHelp.get("psg/drivers/page-drivers-truck", { driverId: that.tempId, plateNumber: plateNumber }).then((res) => {
      this.httpHelp.loadingBlock = false;
      if (res["status"] === this.svrType) {
        console.log("safdsasdsad", res);
        that.myTruck["trucksDataList"] = res["data"];
        that.myTruck["selectedTruckList"] = [];
        this.myTruck["myTruckListDialogFlag"] = true;
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  //设置默认
  defaultTruck(res) {
    let ids = "";
    const that = this;
    that.myTruck["selectedTruckList"].forEach((item) => {
      ids += item.id + ",";
    });
    this.httpHelp.get("psg/drivers/default_truck", { driverId: that.tempId, plateNumber: res.plateNumber }).then((res) => {
      this.httpHelp.loadingBlock = false;
      if (res["status"] == this.svrType) {
        super.showMessage(this.messageSub, "设置成功");
        that.commonGetDriverList();
      } else {
        super.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  // 显示车辆详情
  showTruckDetail(res) {
    console.log("swwew", res);
    this.myTruck["truckDetail"] = res;
    this.myTruck["truckDetailHeader"] = "车辆详情";
    this.myTruck["showTruckDetailFlag"] = true;
    // 标记：此场景下不传递 vehicleType 参数
    (window as any).skipVehicleTypeForViewImg = true;
  }

  // 关闭车辆详情弹窗
  closeTruckDetail() {
    this.myTruck["showTruckDetailFlag"] = false;
    // 清除标记：恢复传递 vehicleType 参数
    delete (window as any).skipVehicleTypeForViewImg;
  }

  // 选择行驶证主页
  async onSelectLicense(event) {
    console.log('[调试-主页] ===== 开始处理行驶证主页上传 =====');
    this.vehicleLicensePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.uploadOSSFile(event["currentFiles"][0], this.regExUtils.TRUCK).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.httpHelp.loadingBlock = false;
    this.vehicleLicensePhotoInput.nativeElement.click();
    this.httpHelp
      .get("psg/common/analysis-img", {
        folder: this.regExUtils.TRUCK,
        imgName: result["uploadName"],
        fileType: "vehicle_license_front",
      })
      .then((res) => {
        console.log('[调试-主页] OCR识别接口返回:', res);
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          if (!res["data"] || !res["data"]["analysisData"]) {
            this.showMessage(this.messageSub, "未识别到行驶证信息，请检查照片是否清晰！", "error");
            return;
          }

          const analysisData = res["data"]["analysisData"];
          console.log('[调试-主页] analysisData:', analysisData);
          console.log('[调试-主页] 车辆类型 vehicleType:', analysisData["vehicleType"]);

          // 保存车辆类型原始字符串用于副页判断
          this['_cachedVehicleType'] = analysisData["vehicleType"] || "";
          console.log('[调试-主页] 已缓存车辆类型字符串:', this['_cachedVehicleType']);

          let issueDate = "";
          if (analysisData["issueDate"] && analysisData["issueDate"].length == 8) {
            let date = analysisData["issueDate"];
            issueDate = date.substring(0, 4) + "-" + date.substring(4, 6) + "-" + date.substring(6, 8);
          }

          let registerDate = "";
          if (analysisData["registerDate"] && analysisData["registerDate"].length == 8) {
            let date = analysisData["registerDate"];
            registerDate = date.substring(0, 4) + "-" + date.substring(4, 6) + "-" + date.substring(6, 8);
          }

          let vehicleType = this.vehicleTypeList[0]["value"];
          if (analysisData["vehicleType"]) {
            let parsedType = this.getParamCodes(analysisData["vehicleType"]);
            vehicleType = parsedType || this.vehicleTypeList[0]["value"];
          }
          console.log('[调试-主页] 转换后的车辆类型代码:', vehicleType);

          this.validateTruckForm.patchValue({
            vehicleLicensePhoto: result["uploadName"],
            issueDate: issueDate,
            issuingOrganizations: analysisData["issuingOrganizations"] || "",
            model: analysisData["model"] || "",
            ownName: analysisData["ownName"] || "",
            plateNumber: analysisData["plateNumber"] || "",
            registerDate: registerDate,
            truckVin: analysisData["truckVin"] || "",
            vehicleType: vehicleType,
          });
          console.log('[调试-主页] 表单已更新');
        } else {
          this.showMessage(this.messageSub, (res["message"] || "识别失败") + "，请检查照片是否清晰！", "error");
        }
      })
      .catch((err) => {
        this.httpHelp.loadingBlock = false;
        this.showMessage(this.messageSub, "识别失败，请稍后重试！", "error");
      });

    this.editUploadFiles.vehicle_license_photo = this.vehicleLicensePhotoUrl;
  }

  getParamCode(value, compare = (a, b) => a === b) {
    return Object.keys(this.energyTypeMap).find((k) => compare(this.energyTypeMap[k], value));
  }
  getParamCodes(value, compare = (a, b) => a === b) {
    return Object.keys(this.vehicleTypeMap).find((k) => compare(this.vehicleTypeMap[k], value));
  }

  // 选择行驶证副页
  async onSelectLicenseBack(event) {
    console.log('[调试-副页] ===== 开始处理行驶证副页上传 =====');
    this.vehicleLicenseBackPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.uploadOSSFile(event["currentFiles"][0], this.regExUtils.TRUCK).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
        console.log('[调试-副页] OSS上传成功:', result);
      } else {
        this.httpHelp.loadingBlock = false;
        console.error('[调试-副页] OSS上传失败:', res);
      }
    });
    this.httpHelp.loadingBlock = false;
    this.vehicleLicenseBackPhotoInput.nativeElement.click();
    this.httpHelp
      .get("psg/common/analysis-img", {
        folder: this.regExUtils.TRUCK,
        imgName: result["uploadName"],
        fileType: "vehicle_license_back",
      })
      .then((res) => {
        console.log('[调试-副页] OCR识别接口返回:', res);
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          if (!res["data"] || !res["data"]["analysisData"]) {
            this.showMessage(this.messageSub, "未识别到行驶证信息，请检查照片是否清晰！", "error");
            console.error('[调试-副页] OCR识别失败: 无analysisData');
            return;
          }

          const analysisData = res["data"]["analysisData"];
          console.log('[调试-副页] OCR识别数据 analysisData:', analysisData);
          
          // 从缓存中获取行驶证主页的车辆类型
          const vehicleTypeFromMainPage = this['_cachedVehicleType'] || "";
          console.log('[调试-副页] 从主页缓存获取的车辆类型:', vehicleTypeFromMainPage);
          
          console.log('[调试-副页] 副页OCR数据:');
          console.log('  - 牵引质量 tractionMass:', analysisData["tractionMass"]);
          console.log('  - 总质量 totalWeight:', analysisData["totalWeight"]);
          console.log('  - 整备质量 loadWeight:', analysisData["loadWeight"]);
          console.log('  - 核定载质量 fullLoadWeight:', analysisData["fullLoadWeight"]);
          
          let a = "",
            b = "",
            c = "";
          let wei = "";
          let fullLoadWeight = "";
          let totalWeight = ""; // 总质量
          let tractionMass = ""; // 牵引质量

          // 安全解析尺寸
          if (analysisData["size"]) {
            let size = analysisData["size"];
            if (size.indexOf("X") > -1 && size.lastIndexOf("X") > -1) {
              a = size.substring(0, size.indexOf("X"));
              b = size.substring(size.indexOf("X") + 1, size.lastIndexOf("X"));
              c = size.substring(size.lastIndexOf("X") + 1, size.length);
              // 去除可能的单位
              c = c.replace(/[^\d]/g, "");
            }
          }

          // 安全解析载重
          if (analysisData["loadWeight"]) {
            let loadWeight = analysisData["loadWeight"];
            wei = loadWeight.replace(/[^\d.]/g, "");
            console.log('[调试-副页] 解析后的整备质量 wei:', wei);
          }

          // 安全解析总质量
          if (analysisData["fullLoadWeight"]) {
            fullLoadWeight = analysisData["fullLoadWeight"].replace(/[^\d.]/g, "");
            console.log('[调试-副页] 解析后的核定载质量 fullLoadWeight:', fullLoadWeight);
          }

          // 安全解析总质量（totalWeight）
          if (analysisData["totalWeight"]) {
            totalWeight = analysisData["totalWeight"].replace(/[^\d.]/g, "");
            console.log('[调试-副页] 解析后的总质量 totalWeight:', totalWeight);
          }

          // 安全解析牵引质量（tractionMass）
          if (analysisData["tractionMass"]) {
            tractionMass = analysisData["tractionMass"].replace(/[^\d.]/g, "");
            console.log('[调试-副页] 解析后的牵引质量 tractionMass:', tractionMass);
          }

          let energyType = this.energyTypeLists[0]["value"];
          if (analysisData["energyType"]) {
            energyType = this.getParamCode(analysisData["energyType"]);
            if (!energyType) {
              energyType = this.energyTypeLists[0]["value"];
            }
          }

          // 使用主页的车辆类型进行判断
          console.log('[调试-副页] ===== 开始计算车辆满载和核载 =====');
          console.log('[调试-副页] 使用主页车辆类型:', vehicleTypeFromMainPage);
          console.log('[调试-副页] 是否包含"牵引车":', vehicleTypeFromMainPage.includes("牵引车"));
          
          let calculatedLoadWeight = wei; // 车辆核载（对应HTML的loadWeight字段）
          let calculatedFullLoadWeight = fullLoadWeight; // 车辆满载（对应HTML的fullLoadWeight字段）

          if (vehicleTypeFromMainPage.includes("牵引车")) {
            console.log('[调试-副页] ✓ 车辆类型包含"牵引车"，使用牵引车计算逻辑');
            // 如果车辆类型包含"牵引车"
            if (tractionMass) {
              calculatedFullLoadWeight = tractionMass; // 车辆满载 = 牵引质量（填入fullLoadWeight字段）
              console.log('[调试-副页] 设置车辆满载(fullLoadWeight) = 牵引质量:', calculatedFullLoadWeight);
              
              // 车辆核载 = (牵引质量 - 整备质量) × 1.05，四舍五入取整（填入loadWeight字段）
              if (wei) {
                const tractionMassNum = parseFloat(tractionMass);
                const loadWeightNum = parseFloat(wei);
                console.log('[调试-副页] 牵引质量数值:', tractionMassNum);
                console.log('[调试-副页] 整备质量数值:', loadWeightNum);
                
                if (!isNaN(tractionMassNum) && !isNaN(loadWeightNum)) {
                  calculatedLoadWeight = Math.round((tractionMassNum - loadWeightNum) * 1.05).toString();
                  console.log('[调试-副页] ✓ 计算车辆核载(loadWeight) = Math.round((', tractionMassNum, '-', loadWeightNum, ') × 1.05) =', calculatedLoadWeight);
                } else {
                  console.warn('[调试-副页] ✗ 数值转换失败，tractionMassNum:', tractionMassNum, 'loadWeightNum:', loadWeightNum);
                }
              } else {
                console.warn('[调试-副页] ✗ 整备质量为空，无法计算车辆核载');
              }
            } else {
              console.warn('[调试-副页] ✗ 牵引质量为空');
            }
          } else {
            console.log('[调试-副页] ✓ 车辆类型不包含"牵引车"，使用普通车辆计算逻辑');
            // 如果车辆类型不包含"牵引车"
            if (totalWeight) {
              calculatedFullLoadWeight = totalWeight; // 车辆满载 = 总质量（填入fullLoadWeight字段）
              console.log('[调试-副页] 设置车辆满载(fullLoadWeight) = 总质量:', calculatedFullLoadWeight);
            } else {
              console.warn('[调试-副页] ✗ 总质量为空，使用整备质量:', wei);
            }
            if (fullLoadWeight) {
              calculatedLoadWeight = fullLoadWeight; // 车辆核载 = fullLoadWeight（填入loadWeight字段）
              console.log('[调试-副页] 设置车辆核载(loadWeight) = fullLoadWeight:', calculatedLoadWeight);
            } else {
              console.warn('[调试-副页] ✗ 核定载质量为空');
            }
          }

          console.log('[调试-副页] ===== 最终填充的数据 =====');
          console.log('[调试-副页] loadWeight字段(车辆核载):', calculatedLoadWeight);
          console.log('[调试-副页] fullLoadWeight字段(车辆满载):', calculatedFullLoadWeight);
          console.log('[调试-副页] 车长 length:', a);
          console.log('[调试-副页] 车宽 width:', b);
          console.log('[调试-副页] 车高 height:', c);
          console.log('[调试-副页] 能源类型 energyType:', energyType);

          this.validateTruckForm.patchValue({
            vehicleLicenseBackPhoto: result["uploadName"],
            energyType: energyType,
            loadWeight: calculatedLoadWeight,
            fullLoadWeight: calculatedFullLoadWeight,
            length: a,
            width: b,
            height: c,
          });
          
          console.log('[调试-副页] 表单更新完成，当前表单值:', this.validateTruckForm.value);
        } else {
          console.error('[调试-副页] OCR识别状态异常:', res);
          this.showMessage(this.messageSub, res["message"] || "识别失败，请检查照片是否清晰！", "error");
        }
      })
      .catch((err) => {
        console.error('[调试-副页] OCR识别异常:', err);
        this.httpHelp.loadingBlock = false;
        this.showMessage(this.messageSub, "识别失败，请稍后重试！", "error");
      });
    this.validateTruckForm.patchValue({
      vehicleLicenseBackPhoto: result["uploadName"],
    });

    this.editUploadFiles.vehicle_license_back_photo = this.vehicleLicenseBackPhotoUrl;
    console.log('[调试-副页] ===== 行驶证副页处理完成 =====');
  }

  // 选择经营许可证
  async onSelectCertificate(event) {
    this.businessCertificatePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], this.regExUtils.TRUCK).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.httpHelp.loadingBlock = false;
    this.validateTruckForm.patchValue({
      businessCertificatePhoto: result["uploadName"],
    });
    this.editUploadFiles.business_certificate_photo = this.businessCertificatePhotoUrl;
  }

  // 选择道路运输证照片
  async onSelectOptCert(event) {
    this.optCertPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.uploadOSSFile(event["currentFiles"][0], this.regExUtils.TRUCK).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.optCertPhotoFileInput.nativeElement.click();
    this.httpHelp.loadingBlock = false;
    this.validateTruckForm.patchValue({
      optCertPhoto: result["uploadName"],
    });
    this.editUploadFiles.opt_cert_photo = this.optCertPhotoUrl;
  }

  vehicleLicenseCheckPhotoUrl;
  @ViewChild("vehicleLicenseCheckFileInput") vehicleLicenseCheckFileInput: ElementRef;

  // 选择车辆年审页照片
  async onSelectVehicleLicenseCheck(event) {
    this.vehicleLicenseCheckPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.uploadOSSFile(event["currentFiles"][0], this.regExUtils.TRUCK).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.httpHelp.loadingBlock = false;
    this.vehicleLicenseCheckFileInput.nativeElement.click();
    this.validateTruckForm.patchValue({
      vehicleLicenseCheckPhoto: result["uploadName"],
    });
    this.editUploadFiles.vehicle_license_check_photo = this.vehicleLicenseCheckPhotoUrl;
  }

  //选择人车证照片
  async onSelectDriverTruck(event) {
    this.driverTruckPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], this.regExUtils.TRUCK).then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.driverTruckInput.nativeElement.click();
    this.httpHelp.loadingBlock = false;
    this.validateTruckForm.patchValue({
      driverTruckPhoto: result["uploadName"],
    });
    this.editUploadFiles.driver_truck_photo = this.driverTruckPhotoUrl;
  }

  mountingAgreementPhotoUrl;
  @ViewChild("mountingAgreementFileInput") mountingAgreementFileInput: ElementRef;

  //选择挂靠协议照片
  async onSelectMountingAgreement(event) {
    this.mountingAgreementPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"]);
    this.httpHelp.loadingBlock = true;
    let result = {};
    // 修改：挂靠协议照片使用 affiliation_agreement 文件夹，调用苏甲上传接口
    await this.ossFileService.cclnewuploadOSSFile(event["currentFiles"][0], "affiliation_agreement").then((res) => {
      if (res["status"] == this.svrType) {
        result = res;
      } else {
        this.httpHelp.loadingBlock = false;
      }
    });
    this.mountingAgreementFileInput.nativeElement.click();
    this.httpHelp.loadingBlock = false;
    this.validateTruckForm.patchValue({
      agreementPhoto: result["uploadName"],
    });
    this.editUploadFiles.mounting_agreement_photo = this.mountingAgreementPhotoUrl;
  }

  //验证添加车辆信息
  queryTruck() {
    if (!this.regExUtils.PLATE_NUMBER_RULE.test(this.myTruck["plateNumber"])) {
      this.showMessage(this.messageSub, "车牌号格式错误,请重新输入！", "error");
      return;
    }
    this.validateTruckForm.reset();
    this.vehicleLicensePhotoUrl = "assets/file/image/xsz.png"; // 行驶证照片
    this.vehicleLicenseBackPhotoUrl = "assets/file/image/xsz.png";
    this.businessCertificatePhotoUrl = "assets/file/image/dlysz.png";
    this.optCertPhotoUrl = "assets/file/image/dlysz.png"; //道路运输证
    this.driverTruckPhotoUrl = "assets/file/image/dlysz.png"; //人车照片
    this.vehicleLicenseCheckPhotoUrl = "assets/file/image/xszfy.png";
    this.mountingAgreementPhotoUrl = "assets/file/image/dlysz.png"; //挂载协议照片

    this.httpHelp.loadingBlock = true;
    this.httpHelp.get("psg/drivers/get-plate-number-list", { plateNumber: this.myTruck["plateNumber"], driverId: this.tempId }).then((res) => {
      this.httpHelp.loadingBlock = false;
      if (res["status"] === this.svrType) {
        const resultData = res["data"];
        // 车牌号不存在，添加新的车辆
        if (!resultData || !resultData["truckInfo"]) {
          this.validateTruckForm.patchValue({
            plateNumber: this.myTruck["plateNumber"],
            vehicleType: this.vehicleTypeList.length > 0 ? this.vehicleTypeList[0]["value"] : "",
            plateColor: this.plateColorLists.length > 0 ? this.plateColorLists[0]["value"] : "",
            energyType: this.energyTypeLists.length > 0 ? this.energyTypeLists[0]["value"] : "",
            isPersonal: this.isPersonalLists.length > 0 ? this.isPersonalLists[0]["value"] : "",
            useCharacter: this.useCharacterLists.length > 0 ? this.useCharacterLists[0].value : "",
            truckType: this.truckModelLists.length > 0 ? this.truckModelLists[0].value : "",
            truckSize: this.truckSizeLists.length > 0 ? this.truckSizeLists[0].value + "" : "",
            teamId: this.teamIdList.length > 0 ? this.teamIdList[0].value + "" : "",
            trailerPlateColor: this.plateColorLists.length > 0 ? this.plateColorLists[0]["value"] : "",
          });
          this.myTruck["truckEditDialogFlag"] = true;
          // this.httpHelp.get('psg/common/get-form-token', {}).then(res => {
          //     if (res['status'] == this.svrType) {
          //         this.formId = res['data']['formId'];
          //         this.formToken = res['data']['formToken'];
          //     } else {

          //     }
          // });
        } else if (resultData["truckInfo"]["id"] && resultData["relDriverTruck"]["driverTruckPhoto"]) {
          // 车牌号已存在，并已绑定人车照
          this.showMessage(this.messageSub, "车辆与司机已绑定，请确认！", "error");
        } else if (resultData["truckInfo"]["id"]) {
          // 车牌号已存在，但未传人车照
          this.myTruck["driver_truck_photo_url"] = "assets/file/image/driverTruckPhoto.png"; // 人车照片
          this.myTruck["truckDetailHeader"] = "上传人车照";
          this.myTruck["truckDetail"] = resultData["truckInfo"];
          this.myTruck.tempTruckId = resultData["truckInfo"]["id"];
          this.myTruck["driverTruckPhotoFlag"] = true;
        }
      } else {
        super.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  // 自动识别驾驶证
  vehicleLicensePhotoUpload(event) {
    this.httpHelp.loadingBlock = false;
    if (event.originalEvent["body"]) {
      const res = event.originalEvent["body"];
      if (res.code == 0) {
        const truckData = res.data;
        this.myTruck["tempTruckId"] = truckData["id"];
        this.validateTruckForm.patchValue({
          plate_number: truckData["plate_number"],
          vehicle_type: truckData["vehicle_type"],
          own_name: truckData["own_name"],
          model: truckData["model"],
          engine_no: truckData["engine_no"],
          register_date: truckData["register_date"],
          issue_date: truckData["issue_date"],
          use_character: truckData["use_character"],
        });
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    }
  }

  // 选择车辆证件图片
  onSelectTruckFile(event, cardType) {
    if (cardType == "vehicle_license_photo") {
      this.myTruck["vehicle_license_photo_url"] = event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"];
      this.editUploadFiles.vehicle_license_photo = event["files"][0];
    } else if (cardType == "business_certificate_photo") {
      this.myTruck["business_certificate_photo_url"] = event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"];
      this.editUploadFiles.business_certificate_photo = event["files"][0];
    } else if (cardType == "driver_truck_photo") {
      this.myTruck["driver_truck_photo_url"] = event["files"][0]["objectURL"]["changingThisBreaksApplicationSecurity"];
      this.editUploadFiles.driver_truck_photo = event["files"][0];
      this.uploadTruckInput.nativeElement.click();
    }
  }

  //保存车辆信息
  async saveUploadDriverTruck() {
    const that = this;
    let url = "add-rel-drivers-truck";
    if (that.myTruck.tempTruckId) {
      url = "update-rel-drivers-truck";
    }
    const options = {
      driverId: that.tempId,
      id: that.myTruck.tempTruckId,
      token: this.formToken,
      formId: this.formId,
    };
    for (const i in this.validateTruckForm.controls) {
      if (this.validateTruckForm.controls[i].invalid) {
        this.validateTruckForm.controls[i].markAsDirty();
        this.validateTruckForm.controls[i].updateValueAndValidity();
        return;
      }
      options[i] = this.validateTruckForm.controls[i].value;
    }
    await this.httpHelp
      .post("psg/drivers/" + url, options)
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] === this.svrType) {
          that.commonGetDriverList();
          that.myTruck["truckEditDialogFlag"] = false;
          that.myTruck["truckCheckDialogFlag"] = false;
          this.showMessage(this.messageSub, res["message"]);
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      })
      .catch((err) => {});
  }

  // 检查是否为牵引车类型
  isTractorVehicleType(): boolean {
    const vehicleTypeValue = this.validateTruckForm?.get("vehicleType")?.value;
    if (!vehicleTypeValue) {
      return false;
    }
    const vehicleTypeName = this.vehicleTypeMap[vehicleTypeValue];
    return vehicleTypeName && vehicleTypeName.includes("牵引车");
  }

  // 校验车辆新增表单，以及图片是否上传
  saveTruck() {
    if (this.editUploadFiles.vehicle_license_photo == "") {
      this.showMessage(this.messageSub, "请上传行驶证照片", "error");
      return;
    }
    if (this.editUploadFiles.opt_cert_photo == "") {
      this.showMessage(this.messageSub, "请上传道路运输证", "error");
      return;
    }
    if (this.editUploadFiles.vehicle_license_check_photo == "") {
      this.showMessage(this.messageSub, "请上传车辆年审页照片", "error");
      return;
    }
    if (this.editUploadFiles.driver_truck_photo == "") {
      this.showMessage(this.messageSub, "请上传人车照", "error");
      return;
    }

    // 检查牵引车类型时，挂车车牌号码和颜色必填
    if (this.isTractorVehicleType()) {
      const trailerPlateNumber = this.validateTruckForm.get("trailerPlateNumber")?.value;
      const trailerPlateColor = this.validateTruckForm.get("trailerPlateColor")?.value;

      if (!trailerPlateNumber || trailerPlateNumber.trim() === "") {
        this.showMessage(this.messageSub, "牵引车类型必须填写挂车车牌号码", "error");
        this.validateTruckForm.get("trailerPlateNumber")?.markAsDirty();
        this.validateTruckForm.get("trailerPlateNumber")?.updateValueAndValidity();
        return;
      }

      if (trailerPlateColor === null || trailerPlateColor === undefined || trailerPlateColor === "") {
        this.showMessage(this.messageSub, "牵引车类型必须选择挂车车牌颜色", "error");
        this.validateTruckForm.get("trailerPlateColor")?.markAsDirty();
        this.validateTruckForm.get("trailerPlateColor")?.updateValueAndValidity();
        return;
      }
    }

    // 特殊处理主车车牌颜色字段（plateColor），因为值可能为0
    const plateColorValue = this.validateTruckForm.get("plateColor")?.value;
    if (plateColorValue === null || plateColorValue === undefined || plateColorValue === "") {
      this.showMessage(this.messageSub, "请选择车牌颜色", "error");
      this.validateTruckForm.get("plateColor")?.markAsDirty();
      this.validateTruckForm.get("plateColor")?.updateValueAndValidity();
      return;
    }

    for (const i in this.validateTruckForm.controls) {
      // 跳过plateColor字段的验证，因为已经在上面单独处理了
      if (i === "plateColor") {
        continue;
      }
      if (this.validateTruckForm.controls[i].invalid) {
        this.validateTruckForm.controls[i].markAsDirty();
        this.validateTruckForm.controls[i].updateValueAndValidity();
        return;
      }
    }
    this.configSrv.confirm({
      message: "确定保存车辆信息吗",
      icon: "pi pi-exclamation-triangle",
      header: "保存确认",
      acceptLabel: "确定",
      rejectLabel: "取消",
      rejectButtonStyleClass: "p-button-raised p-button-text p-button-plain",
      accept: () => {
        this.httpHelp.loadingBlock = true;
        this.saveUploadDriverTruck();
      },
      reject: () => {},
      key: "confirm",
    });
  }

  // 查看司机人车照
  checkDriverTruckPhoto(data) {
    delete (window as any).skipVehicleTypeForViewImg;
    this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, data["driverTruckPhoto"], 2).then((res) => {
      if (res["status"] == this.svrType) {
        this.imagePreviewService.preview([res["data"]["url"]]);
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }

  // 审核司机
  checkRelDriverTruck() {
    this.checkDriverForm.patchValue({
      checkFlag: 2,
      checkLog: "",
    });
    this.currentDriverCheckFlag = 2;
    this.myTruck["checkDriverTruckDialogFlag"] = true;
  }
  //保存司机关联车辆审核
  saveCheckDriverTruck() {
    let flag = false;
    let ids = "";
    this.myTruck["selectedTruckList"].forEach((item) => {
      ids += item.id + ",";
      if (item.checkFlag != 1) {
        flag = true;
      }
    });
    if (flag) {
      this.showMessage(this.messageSub, "选中数据中有已审核结束的数据，不能重复审核", "error");
      return;
    }
    if (this.currentDriverCheckFlag == 3 && this.checkDriverForm.get("checkLog").value == "") {
      this.showMessage(this.messageSub, "请填写审核不通过原因", "error");
      return;
    }
    this.httpHelp.loadingBlock = true;
    this.httpHelp
      .post("psg/drivers/check-rel-drivers-truck", {
        relDriverTruckIds: ids,
        checkFlag: this.checkDriverForm.controls.checkFlag.value,
        checkLog: this.checkDriverForm.controls.checkLog.value,
      })
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          this.myTruck["checkDriverTruckDialogFlag"] = false;
          this.commonGetDriverList();
          this.showMessage(this.messageSub, res["message"]);
        } else {
          this.showMessage(this.messageSub, res["message"], "error");
        }
      });
  }

  // 删除绑定车辆
  delMyTruck() {
    let ids = "";
    const that = this;
    that.myTruck["selectedTruckList"].forEach((item) => {
      ids += item.id + ",";
    });
    this.httpHelp.delete({
      confirm: this.configSrv,
      url: "psg/drivers/delete-rel-drivers-truck",
      deleteId: ids,
      success: (res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType) {
          that.commonGetDriverList();
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      },
    });
  }

  //保存上传人车照片数据
  async saveUploadDriverTruckPhoto() {
    // 上传文件
    let driver_truck_photo_url = ""; // 人车照
    if (this.editUploadFiles.driver_truck_photo != "") {
      await this.ossFileService.cclnewuploadOSSFile(this.editUploadFiles.driver_truck_photo, this.regExUtils.TRUCK).then((res) => {
        if (res["status"] == this.svrType) {
          driver_truck_photo_url = res["uploadName"];
        } else {
          that.httpHelp.loadingBlock = false;
          that.showMessage(this.messageSub, res["message"], "error");
        }
      });
    }
    const that = this;
    const options = {
      driverId: that.tempId,
      truckId: that.myTruck.tempTruckId,
    };
    if (driver_truck_photo_url != "") {
      options["driverTruckPhoto"] = driver_truck_photo_url;
    }
    this.httpHelp.loadingBlock = true;
    await this.httpHelp
      .post("psg/drivers/save-driver-truck-photo", options)
      .then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] === this.svrType) {
          that.commonGetDriverList();
          this.myTruck["truckCheckDialogFlag"] = false;
          this.myTruck["driverTruckPhotoFlag"] = false;
          this.showMessage(this.messageSub, res["message"]);
          this.editUploadFiles.driver_truck_photo = "";
        } else {
          super.showMessage(this.messageSub, res["message"], "error");
        }
      })
      .catch((err) => {});
  }

  //关联车辆新增
  editMyTruck() {
    this.myTruck["plateNumber"] = "";
    this.myTruck["tempTruckId"] = null;
    this.myTruck["truckCheckDialogFlag"] = true;
  }

  // 上传司机人车照
  uploadTruckPhoto(res) {
    this.myTruck["truckDetailHeader"] = res.plateNumber;
    this.tempId = res.driverId;
    this.myTruck["tempTruckId"] = res.truckId;
    this.myTruck["driver_truck_photo_url"] = "assets/file/image/driverTruckPhoto.png";
    this.myTruck["driverTruckPhotoFlag"] = true;
  }

  //查看图片
  priviewImgs(urls) {
    let files = [];
    //通过该种方式直接预览本地上传文件
    if (urls.changingThisBreaksApplicationSecurity == undefined) {
      files.push(urls);
    } else {
      files.push(urls.changingThisBreaksApplicationSecurity);
    }
    this.imagePreviewService.preview(files);
  }

  batchMobilePhone() {
    this.batchMobilePhoneDialog = true;
  }

  //保存批次号
  batchNo() {
    let no = this.batchNoForm.get("batchNo").value;
    if (no != null) {
      //将换行符转换为逗号并去掉尾部逗号
      var reg = /,$/gi;
      var warningPhones = no.replace(/\n/g, ",");
      var warningPhones_str = warningPhones.replace(reg, "");
      let nos = [];
      let ids = "";
      if (warningPhones_str && warningPhones_str.lastIndexOf(",") > 0) {
        nos = warningPhones_str.split(",");
        if (nos.length > 0) {
          nos.forEach((item) => {
            if (item != "" && item != null) {
              ids += item + ",";
            }
          });
        }
      } else {
        ids = warningPhones_str;
      }
      this.searchForm.patchValue({
        mobilePhones: ids.replace(/\s*/g, ""),
      });
    }
    this.dialogBlock = false;
    this.batchMobilePhoneDialog = false;
  }

  batchIdCardNo() {
    this.batchIdCardNoDialog = true;
  }

  batchIdNo() {
    let no = this.batchIdCardNoForm.get("batchIdCardNo").value;
    //将换行符转换为逗号并去掉尾部逗号
    if (no != null) {
      var reg = /,$/gi;
      var warningPhones = no.replace(/\n/g, ",");
      var warningPhones_str = warningPhones.replace(reg, "");
      let nos = [];
      let ids = "";
      if (warningPhones_str && warningPhones_str.lastIndexOf(",") > 0) {
        nos = warningPhones_str.split(",");
        if (nos.length > 0) {
          nos.forEach((item) => {
            if (item != "" && item != null) {
              ids += item + ",";
            }
          });
        }
      } else {
        ids = warningPhones_str;
      }
      this.searchForm.patchValue({
        idCardNos: ids.replace(/\s*/g, ""),
      });
    }
    this.dialogBlock = false;
    this.batchIdCardNoDialog = false;
  }
  // ================================我的车辆结束============================ //

  /*========================司机审核开始================================ */
  showDriverCheckFlag = false;
  localDriverDetail = {};
  idCardNoFront;
  idCardNoBack;
  drivingLicense;
  imgPriview: ""; // 展示图
  thumbnailImageSrc = []; // 缩略图
  current = 0; // 旋转角度
  imgDescribe = "";
  relTruckList = [];
  bankAccountList = [];
  relAgentorList = [];
  relAgentList = [];
  relCusList = [];
  checkDriverFlag(event) {
    this.localDriverDetail["id"] = event["id"];
    this.showDriverCheckFlag = true;
  }
  // 预览右侧缩略图
  previewThumbnailImage(data) {
    // var img = document.querySelector('.img-preview-img').getAttribute("src")
    let show_photo_list = [];
    let index = 0;

    show_photo_list.push(data.businessCertificatePhoto);
    this.imagePreviewService.preview(show_photo_list, index);
  }
  // 向左旋转
  handleTurnLeft() {
    let img = <HTMLImageElement>document.querySelector(".img-preview");
    this.current = (this.current - 90) % 360;
    img.style.transform = "rotate(" + this.current + "deg)";
  }
  // 向右旋转
  handleTurnright() {
    let img = <HTMLImageElement>document.querySelector(".img-preview");
    this.current = (this.current + 90) % 360;
    img.style.transform = "rotate(" + this.current + "deg)";
  }
  // 预览图切换
  previewImgIndex = 0; // 小图下标
  afiles = [];
  handlePreviewImgClick(item, i) {
    this.imgPriview = item.url;
    this.imgDescribe = item.title;
    this.previewImgIndex = i;
    this.current = 0;
    this.afiles.push(this.imgPriview);
  }
  /*========================司机审核结束================================ */

  //查看法大大协议
  showFadadaDriverFlag = false; //弹框开关
  agreeHeaderTitle = ""; //标题
  safeUrl; //协议链接地址
  showFadadaDriverAgree(res) {
    if (res["contractNo"]) {
      this.agreeHeaderTitle = "委托代开协议（" + res["realname"] + "）";
      this.httpHelp.loadingBlock = true;
      this.httpHelp.get("psg/drivers/get-driver-fadada", { contractNo: res["contractNo"] }).then((res) => {
        this.httpHelp.loadingBlock = false;
        if (res["status"] == this.svrType && res["data"]) {
          this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res["data"]["signUrl"]);
          // var a = document.createElement('a')
          // a.href = res['data']['signUrl'];
          // a.download = '委托代征协议'
          // a.target = '_blank'
          // a.click()
          this.showFadadaDriverFlag = true;
        } else {
          super.showMessage(this.messageSub, "获取法大大协议失败：" + res["message"], "error");
        }
      });
    }
  }

  ngOnInit(): void {
    const that = this;
    super.initCurrentPage(that);

    that.operatePageButtons = that.setOperateButtons((value) => {
      if (value == 4) {
        that.editColumnDialog = true;
      } else if (value == 3) {
        that.changeTableList();
      } else if (value == 2) {
        that.showMessage(that.messageSub, "在线文档暂未开发", "info");
      } else {
        that.showMessage(that.messageSub, "设置筛选条件暂未开发", "info");
      }
    });
    //司机编辑表单初始化
    this.validateForm = this.fb.group({
      realname: [null, [Validators.required]],
      mobilePhone: [null, [Validators.required]],
      sjUserId: [null],
      politicalOutlook: [null, [Validators.required]],
      sex: [null],
      birthDate: [null],
      idCardNo: [null, [Validators.required]],
      startUseDate: [null, [Validators.required]],
      endUseDate: [null, [Validators.required]],
      address: [null, [Validators.required]],
      idCardNoFront: [null],
      idCardNoBack: [null],
      qualificationCertNo: [null, [Validators.required]],
      insureProvince: [null, [Validators.required]],
      qualificationCertIssueAreaCode: [null, [Validators.required]],
      qualificationCertExpireTime: [null],
      driverType: [null, [Validators.required]],
      drivingLicenseNo: [null, [Validators.required]],
      drivingStartUseDate: [null, [Validators.required]],
      drivingEndUseDate: [null, [Validators.required]],
      issuingOrganizations: [null],
      drivingLicensePhoto: [null],
      drivingLicenseBackPhoto: [null],
      qualificationCertPhoto: [null],
      remark: [null],
    });
    this.bindTruckUserForm = this.fb.group({
      //  truckIds: [null, [Validators.required]],
      // sourcePrice: [null, [Validators.required]],//原价
      SjuserId: [null], //售价

      driverId: [null],
    });
    this.checkDriverForm = this.fb.group({
      checkFlag: [null],
      checkLog: [null],
    });

    this.validateBankForm = this.fb.group({
      accountNo: [null],
      bankImg: [null],
      bankName: [null],
      bankReservePhone: [null],
      validateNum: [null],
      cardType: [null],
    });

    this.batchNoForm = this.fb.group({
      batchNo: [null, [Validators.required]],
    });

    this.batchIdCardNoForm = this.fb.group({
      batchIdCardNo: [null, [Validators.required]],
    });
    this.memberValidateForm = this.fb.group({
      effectTime: [null, [Validators.required]],
      level: [null, [Validators.required]],
      realPrice: [null, [Validators.required]],
      salesman: [null, [Validators.required]],
    });

    this.truckValidateForm = this.fb.group({
      plateNumber: [null],
    });

    this.checkWaybillForm = this.fb.group({
      checkLog: [null],
      checkLogTips: [1],
    });

    this.validateFormPhone = this.fb.group({
      idCardNo: [null],
      mobilePhone: [null],
      sjUserId: [null],
      address: [null],
      realname: [null],
      sex: [null],
      card: [null],
      birthDate: [null],
      idCardImgName: [null],
    });

    //司机关联托运方表单
    this.validateRelDriverForm = this.fb.group({
      cusId: [null, [Validators.required]],
    });

    //司机关联区域合伙人表单
    this.validateRelAgentDriverForm = this.fb.group({
      agentId: [null, [Validators.required]],
    });

    this.validateTruckForm = this.fb.group({
      plateNumber: [null, [Validators.required]],
      vehicleType: [null, [Validators.required]],
      fullLoadWeight: [null, [Validators.required]],
      loadWeight: [null, [Validators.required]],
      plateColor: [null, [Validators.required]],
      energyType: [null, [Validators.required]],
      isPersonal: [null, [Validators.required]],
      ownName: [null, [Validators.required]],
      businessCertificate: [null],
      businessCertificateExpireTime: [null],
      optCertNo: [null, [Validators.required]],
      optCertExpireTime: [null, [Validators.required]],
      vehicleLicensePhoto: [null],
      vehicleLicenseBackPhoto: [null],
      businessCertificatePhoto: [null],
      optCertPhoto: [null],
      vehicleLicenseCheckPhoto: [null],
      trailerPlateNumber: [null],
      trailerPlateColor: [null],
      length: [null, [Validators.required]],
      width: [null, [Validators.required]],
      height: [null, [Validators.required]],
      trailerVolume: [null],
      model: [null],
      ownCarrierId: [null],
      useCharacter: [null, [Validators.required]],
      truckVin: [null, [Validators.required]],
      issuingOrganizations: [null, [Validators.required]],
      registerDate: [null, [Validators.required]],
      issueDate: [null, [Validators.required]],
      isOnline: [null],
      remark: [null],
      truckType: [null], // 移除必填验证，字段已隐藏
      truckSize: [null],
      driverTruckPhoto: [null],
      teamId: [null],
      vehicleExaminedExpirationDate: [null, [Validators.required]],
      axleCount: [null, [Validators.required]],
      agreementPhoto: [null],
    });

    this.searchForm = this.fb.group({
      startTime: [null],
      endTime: [null],
      idCardNo: [null],
      realname: [null],
      saleUserName: [null],
      checkFlag: [null],
      mobilePhone: [null],
      cusId: [null],
      sex: [null],
      signStatus: [null],
      mobilePhones: [null],
      idCardNos: [null],
      useStatus: [null],
      status: [null],
      agentId: [null],
      blacklistStatus: [null],
      certificateExpiredCount: [null],
    });

    //签署委托代征
    this.signContractForm = this.fb.group({
      signContract: [null],
    });

    // 导出表单
    this.exportForm = this.fb.group({
      exportTemplateType: [null],
    });

    this.httpHelp.get("psg/agent/query-agent-list", {}).then((res) => {
      if (res["status"] == "success") {
        this.agentMap = {};
        const tempAgentIdList = res["data"];
        tempAgentIdList.forEach((e) => {
          this.agentMap[e["id"]] = e["agentName"];
          // this.agentIdList.push({
          //   label: e['name'],
          //   value: e['id']
          // });
        });
        this.searchAgentList = this.getLocalDropdown(this.agentMap, true);
        this.agentIdList = this.getLocalDropdown(this.agentMap, false);
      } else {
        // this.showMessage()
      }
    });
    //初始化代码表字典
    this.httpHelp
      .get("psg/diction/dicType", { dicTypes: "vehicle_classification_code,use_type,brand,truck_length,driving_license,political_outlook,plate_color,energy_type,is_personal,use_character,truck_length,truck_type" })
      .then((res) => {
        if (res["status"] == "success") {
          const tempGoodsTypeList = res["data"];
          tempGoodsTypeList.forEach((e) => {
            if (e["dicType"] == "vehicle_classification_code") {
              this.vehicleTypeMap[e["value"]] = e["text"];
              this.vehicleTypeList.push({
                label: e["text"],
                value: e["value"],
              });
            } else if (e["dicType"] == "brand") {
              this.modelList.push({
                label: e["text"],
                value: e["value"],
              });
            } else if (e["dicType"] == "use_type") {
              this.useCharacterList.push({
                label: e["text"],
                value: e["value"],
              });
            } else if (e["dicType"] == "truck_length") {
              this.truckSizeList.push({
                label: e["text"],
                value: e["value"],
              });
            } else if (e["dicType"] == "driving_license") {
              this.driverTypeMap[e["value"]] = e["text"];
              this.driverTypeList.push({
                label: e["text"],
                value: e["value"],
              });
            } else if (e["dicType"] == "political_outlook") {
              //政治面貌
              this.politicalOutlookMap[e["value"]] = e["text"];
              this.politicalOutlookLists.push({
                label: e["text"],
                value: e["value"],
              });
            }
            //车牌颜色
            if (e["dicType"] == "plate_color") {
              this.plateColorMap[e["value"]] = e["text"];
              this.plateColorLists.push({
                label: e["text"],
                value: e["value"],
              });
            }
            //车辆能源类型
            if (e["dicType"] == "energy_type") {
              this.energyTypeMap[e["value"]] = e["text"];
              this.energyTypeLists.push({
                label: e["text"],
                value: e["value"],
              });
            }
            //车辆属性
            if (e["dicType"] == "is_personal") {
              this.isPersonalMap[e["value"]] = e["text"];
              this.isPersonalLists.push({
                label: e["text"],
                value: e["value"],
              });
            }
            //使用性质
            if (e["dicType"] == "use_character") {
              this.useCharacterMap[e["value"]] = e["text"];
              this.useCharacterLists.push({
                label: e["text"],
                value: e["value"],
              });
            }
            //车长
            if (e["dicType"] == "truck_length") {
              this.truckSizeMap[e["value"] + ""] = e["text"];
              this.truckSizeLists.push({
                label: e["text"],
                value: e["value"] + "",
              });
            }
            //车型
            if (e["dicType"] == "truck_type") {
              this.truckModelMap[e["value"]] = e["text"];
              this.truckModelLists.push({
                label: e["text"],
                value: e["value"],
              });
            }
          });
        } else {
          // this.showMessage()
        }
      });

    this.httpHelp.get("psg/shipper/query-cust-list", {}).then((res) => {
      if (res["status"] == "success") {
        this.shipperMap = {};
        const tempShipperIdList = res["data"];
        tempShipperIdList.forEach((e) => {
          this.shipperMap[e["id"]] = e["name"];
          // this.shipperIdList.push({
          //   label: e['name'],
          //   value: e['id']
          // });
        });
        this.searchShipperList = this.getLocalDropdown(this.shipperMap, true);
        this.ShipperList = this.getLocalDropdown(this.shipperMap, false);
      } else {
        // this.showMessage()
      }
    });

    //车主信息
    this.httpHelp.get("psg/team/get-team", {}).then((res) => {
      if (res["status"] == "success") {
        const tempShipperIdList = res["data"]["pageList"];
        that.teamIdList.push({
          value: "",
          label: "请选择车主",
        });
        tempShipperIdList.forEach((e) => {
          this.teamIdList.push({
            label: e["realname"],
            value: e["id"],
          });
        });
      } else {
        // this.showMessage()
      }
    });

    that.searchFormName = {
      startTime: { show: true, label: "开始时间" },
      endTime: { show: true, label: "截至时间" },
      realname: { show: true, label: "司机名称" },
      saleUserName: { show: true, label: "业务员" },
      mobilePhone: { show: true, label: "手机号" },
      idCardNo: { show: true, label: "身份证号" },
      sex: { show: true, label: "性别" },
      cusId: { show: true, label: "托运方" },
      agentId: { show: true, label: "区域合伙人" },
      useStatus: { show: true, label: "工作状态" },
      status: { show: true, label: "司机状态" },
      signStatus: { show: true, label: "签署状态" },
      blacklistStatus: { show: true, label: "是否黑名单" },
      mobilePhones: { show: true, label: "批量司机" },
      idCardNos: { show: true, label: "批量身份证号" },
    };
    super.initSearch(this, this.searchForm, [], [], true);
    // this.queryList();
    super.setScroll(this.router, "carryManager/driver/driver.html", this.el);
    this.route.queryParamMap.subscribe((params) => {
      console.log("ssss", params.get("certificateExpiredCount"));
      if (params.get("certificateExpiredCount") !== null) {
        this.changeCertificateExpiredCountItems(Number(params.get("certificateExpiredCount")));
      } else {
        this.changeCertificateExpiredCountItems("");
      }
    });
    this.changeSearchStatus("");
    this.querySalesList();
    this.getAreaList();
  }

  // ==================================查询部分设置==================================== //
  chearchFormObserver = null;
  searchItems = [];
  searchFormName = {};
  @ViewChild("driverSearchPanel") searchPanel: ElementRef;

  resetQuery() {
    this.searchForm.reset();
    this.batchNoForm.reset();
    this.batchIdCardNoForm.reset();
    super.initSearch(this, this.searchForm, [], [], true);
    this.hideSearchValue = [];
    this.certificateExpiredCountItems.forEach((e) => {
      if (e.value === "") {
        e.checkFlag = true;
      } else {
        e.checkFlag = false;
      }
    });
    this.queryList();
  }

  showEsQuery() {
    this.showEsSearch = !this.showEsSearch;
    const that = this;
    if (this.showEsSearch) {
      that.searchItems.forEach((e) => {
        e.show = true;
      });
      for (let key in that.searchFormName) {
        that.searchFormName[key]["show"] = true;
      }
      this.hideSearchValue = [];
    } else {
      that.resetFormItem();
    }
  }

  deleteEsQuery(item) {
    this.hideSearchValue = this.hideSearchValue.filter((e) => e.key != item.key);
    this.searchForm.get(item["key"]).setValue(null);
  }

  ngAfterViewInit(): void {
    const that = this;
    let formItems = [];
    formItems = Array.from(that.searchPanel.nativeElement.querySelectorAll("form >.form-item"));
    formItems.forEach((item) => {
      that.searchItems.push({
        name: item.getAttribute("name"),
        show: true,
        width: item.offsetWidth + 21, //
      });
    });
    that.resetFormItem();
  }

  ngOnDestroy(): void {
    if (this.chearchFormObserver) {
      this.chearchFormObserver.unobserve();
    }
    if (this.smsTimer) {
      clearInterval(this.smsTimer);
      this.smsTimer = null;
    }
  }

  formResize(event) {
    if (!this.showEsSearch) {
      this.resetFormItem(event.newRect.width);
    }
  }
  insProvinceList = [];
  insCityList = [];
  resetFormItem(width?) {
    const that = this;
    let currFormWidth = 0; // 变化后得宽度
    if (width) {
      currFormWidth = width;
    } else {
      let form = that.searchPanel.nativeElement.querySelector("form");
      currFormWidth = form.offsetWidth;
    }
    let currFormItemsWidth = 0;
    this.searchItems.forEach((e) => {
      // 计算显示宽度
      if (e["show"]) {
        currFormItemsWidth += e.width;
      }
    });

    if (currFormItemsWidth > currFormWidth) {
      for (let i = that.searchItems.length - 1; i >= 0; i--) {
        if (that.searchItems[i].show) {
          that.searchItems[i].show = false;
          if (currFormWidth > currFormItemsWidth - that.searchItems[i].width) {
            break;
          }
          currFormItemsWidth -= that.searchItems[i].width;
        }
      }
    } else {
      for (let i = 0; that.searchItems.length > i; i++) {
        if (!that.searchItems[i].show) {
          if (currFormWidth > currFormItemsWidth + that.searchItems[i].width) {
            that.searchItems[i].show = true;
          }
          break;
        }
      }
    }
    this.hideSearchValue = [];
    that.searchItems.forEach((i) => {
      that.searchFormName[i.name].show = i.show;
      if (!i.show) {
        if (this.searchForm.get(i.name).value || that.searchForm.get(i.name).value == 0) {
          this.hideSearchValue.push({
            key: i.name,
            value: that.keysFunction[i.name] ? that.keysFunction[i.name].format(that.searchForm.get(i.name).value) : that.searchForm.get(i.name).value,
            label: that.searchFormName[i.name].label,
          });
        }
      }
    });
  }
  getAreaList() {
    this.httpHelp.get("psgsys/sj/areainfo/getAreaList?pAreaCode=0" + "&provinceName=", {}).then((res) => {
      if (res["code"] === 0) {
        // this.validateTruckForm.patchValue({
        //     insureCity: ''
        // })
        this.insProvinceList = [
          {
            label: "--请选择--",
            value: "",
          },
        ];
        const list = res["data"];
        list.forEach((e) => {
          this.insProvinceList.push({
            label: e["areaName"],
            value: e["areaCode"],
          });
        });
      } else {
        this.showMessage(this.messageSub, res["message"], "error");
      }
    });
  }
  changeinsProvinceList(data) {
    console.log('=== changeinsProvinceList 调试 ===');
    console.log('传入的data:', data);
    console.log('data.value:', data.value);
    
    if (data.value == 0) {
      console.log('data.value为0，直接返回');
      return;
    }
    
    const apiUrl = "psgsys/sj/areainfo/getAreaList?pAreaCode=" + data.value + "&provinceName=";
    console.log('请求URL:', apiUrl);
    
    return this.httpHelp.get(apiUrl, {}).then((res) => {
      console.log('API响应:', res);
      
      if (res["code"] === 0) {
        this.insCityList = [
          {
            label: "--请选择--",
            value: "",
          },
        ];
        const list = res["data"];
        console.log('城市数据列表:', list);
        
        list.forEach((e) => {
          this.insCityList.push({
            label: e["areaName"],
            value: e["areaCode"],
          });
        });
        
        console.log('最终城市列表:', this.insCityList);
      } else {
        console.error('API返回错误:', res["message"]);
        this.showMessage(this.messageSub, res["message"], "error");
      }
    }).catch(err => {
      console.error('API请求失败:', err);
      throw err;
    });
  }
  userListArr = [];
  selectBindCRes: any = {};
  batchBindUserDialogFlag = false;
  unbindC(res) {
    let that = this;
    this.httpHelp
      .get("psg/drivers/update-bindSjuser", {
        SjuserId: 0,
        driverId: res.id,
      })
      .then((res) => {
        if (res["code"] === "300") {
          that.queryList();
          super.showMessage(this.messageSub, res["message"], "success");
        } else {
          super.showMessage(this.messageSub, res["msg"], "error");
        }
      })
      .catch((err) => {});
  }
  bindC(res) {
    let that = this;
    this.batchBindUserDialogFlag = true;
    this.selectBindCRes = res;
    this.bindTruckUserForm.patchValue({
      driverId: this.selectBindCRes.id,
    });
    this.getPlateNumber();
  }
  getPlateNumber(data?) {
    let that = this;
    let plateNumber1 = "";
    const httpOptions = { custType: 1 };
    if (data) {
      plateNumber1 = data.filter;
    }

    this.currentEvent = {
      first: 0,
      pageNo: 1,
      pageSize: 50,
      userPhone: plateNumber1,
    };
    this.httpHelp
      .get("psgsys/sjUser/page", {
        ...httpOptions,
        ...this.currentEvent,
      })
      .then((res) => {
        if (res["code"] == 0) {
          let obj = {
            value: null,
            label: "--请选择--",
          };
          that.userListArr = res["data"]["list"].map((x) => {
            return {
              value: x.id,
              label: x.userPhone,
            };
          });
          that.userListArr.unshift(obj);
          console.log(that.userListArr);
          super.reloadScroll(this.el);
        } else {
          this.showMessage(this.messageSub, res["msg"], "error");
        }
      });
  }
  async saveTruckBindUser() {
    let that = this;

    // for (const i in this.bindTruckUserForm.controls) {
    //   // if (this.validateTruckForm.controls[i].invalid) {
    //   //   this.validateTruckForm.controls[i].markAsDirty();
    //   //   this.validateTruckForm.controls[i].updateValueAndValidity();
    //   //   return;
    //   // }
    //   options[i] = this.bindTruckUserForm.controls[i].value;
    // }

    await this.httpHelp
      .get("psg/drivers/update-bindSjuser", this.bindTruckUserForm.value)
      .then((res) => {
        if (res["code"] === "300") {
          that.batchBindUserDialogFlag = false;
          that.httpHelp.loadingBlock = false;
          that.dialogBlock = false;
          that.queryList();
          super.showMessage(this.messageSub, res["message"], "success");
        } else {
          super.showMessage(this.messageSub, res["msg"], "error");
        }
      })
      .catch((err) => {});
  }

  saveChangeTruckBindUser() {
    // for (let item of this.selectedItem) {
    //   if (item.sjUserId != null && item.sjUserId > 0) {
    //     super.showMessage(this.messageSub, item.plateNumber + '车辆已经绑定手机号', 'error');
    //     return;
    //   }
    // }

    this.configSrv.confirm({
      message: "确定绑定C端吗",
      icon: "pi pi-exclamation-triangle",
      header: "修改保存确认",
      acceptLabel: "确定",
      rejectLabel: "取消",
      rejectButtonStyleClass: "p-button-raised p-button-text p-button-plain",
      accept: () => {
        this.httpHelp.loadingBlock = true;

        this.saveTruckBindUser();
      },
      reject: () => {},
      key: "confirm",
    });
  }
  openAccount(res) {
    console.log("rrrrr", res);
    this.configSrv.confirm({
      message: "确定开户吗",
      icon: "pi pi-exclamation-triangle",
      header: "保存确认",
      acceptLabel: "确定",
      rejectLabel: "取消",
      rejectButtonStyleClass: "p-button-raised p-button-text p-button-plain",
      accept: () => {
        this.httpHelp.loadingBlock = true;
        this.httpHelp
          .get("psgsys/sj/nj/xin/open", {
            accountId: res.id,
            driverId: this.driverId,
          })
          .then((res) => {
            if (res["code"] === 0) {
              this.queryMyBanckCard();
              super.showMessage(this.messageSub, "操作成功", "success");
            } else {
              super.showMessage(this.messageSub, res["msg"], "error");
            }
            this.batchBindUserDialogFlag = false;
            this.httpHelp.loadingBlock = false;
            this.dialogBlock = false;
          })
          .catch((err) => {});
      },
      reject: () => {},
      key: "confirm",
    });
  }
  showFacePhoto(res) {
    console.log("r", res);
    if (res.faceUrl) {
      this.imagePreviewService.preview([res.faceUrl]);
    }
  }
  certificateExpiredCountItems = [
    {
      label: "全部",
      value: "",
      checkFlag: true,
    },
    {
      label: "已过期",
      value: 1,
      checkFlag: false,
    },
  ];
  // ==================================查询部分设置结束==================================== //
}
